var map = {
	"./brands/42-group.svg": [
		9502,
		9502
	],
	"./brands/500px.svg": [
		83890,
		83890
	],
	"./brands/accessible-icon.svg": [
		921,
		921
	],
	"./brands/accusoft.svg": [
		31939,
		31939
	],
	"./brands/adn.svg": [
		52776,
		52776
	],
	"./brands/adversal.svg": [
		94488,
		94488
	],
	"./brands/affiliatetheme.svg": [
		2469,
		2469
	],
	"./brands/airbnb.svg": [
		1569,
		1569
	],
	"./brands/algolia.svg": [
		23697,
		23697
	],
	"./brands/alipay.svg": [
		45312,
		45312
	],
	"./brands/amazon-pay.svg": [
		74180,
		74180
	],
	"./brands/amazon.svg": [
		44958,
		44958
	],
	"./brands/amilia.svg": [
		92998,
		92998
	],
	"./brands/android.svg": [
		21340,
		21340
	],
	"./brands/angellist.svg": [
		15106,
		15106
	],
	"./brands/angrycreative.svg": [
		79265,
		79265
	],
	"./brands/angular.svg": [
		31376,
		31376
	],
	"./brands/app-store-ios.svg": [
		64342,
		64342
	],
	"./brands/app-store.svg": [
		22900,
		22900
	],
	"./brands/apper.svg": [
		92851,
		92851
	],
	"./brands/apple-pay.svg": [
		6468,
		6468
	],
	"./brands/apple.svg": [
		44539,
		44539
	],
	"./brands/artstation.svg": [
		53262,
		53262
	],
	"./brands/asymmetrik.svg": [
		33400,
		33400
	],
	"./brands/atlassian.svg": [
		41467,
		41467
	],
	"./brands/audible.svg": [
		82196,
		82196
	],
	"./brands/autoprefixer.svg": [
		64476,
		64476
	],
	"./brands/avianex.svg": [
		72137,
		72137
	],
	"./brands/aviato.svg": [
		94636,
		94636
	],
	"./brands/aws.svg": [
		45413,
		45413
	],
	"./brands/bandcamp.svg": [
		46843,
		46843
	],
	"./brands/battle-net.svg": [
		36815,
		36815
	],
	"./brands/behance.svg": [
		98654,
		98654
	],
	"./brands/bilibili.svg": [
		5421,
		5421
	],
	"./brands/bimobject.svg": [
		74822,
		74822
	],
	"./brands/bitbucket.svg": [
		21039,
		21039
	],
	"./brands/bitcoin.svg": [
		4106,
		4106
	],
	"./brands/bity.svg": [
		66701,
		66701
	],
	"./brands/black-tie.svg": [
		77505,
		77505
	],
	"./brands/blackberry.svg": [
		61230,
		61230
	],
	"./brands/blogger-b.svg": [
		88528,
		88528
	],
	"./brands/blogger.svg": [
		77408,
		77408
	],
	"./brands/bluetooth-b.svg": [
		43191,
		43191
	],
	"./brands/bluetooth.svg": [
		88826,
		88826
	],
	"./brands/bootstrap.svg": [
		48346,
		48346
	],
	"./brands/bots.svg": [
		70579,
		70579
	],
	"./brands/btc.svg": [
		21223,
		21223
	],
	"./brands/buffer.svg": [
		37362,
		37362
	],
	"./brands/buromobelexperte.svg": [
		57541,
		57541
	],
	"./brands/buy-n-large.svg": [
		21669,
		21669
	],
	"./brands/buysellads.svg": [
		21213,
		21213
	],
	"./brands/canadian-maple-leaf.svg": [
		63447,
		63447
	],
	"./brands/cc-amazon-pay.svg": [
		62861,
		62861
	],
	"./brands/cc-amex.svg": [
		45022,
		45022
	],
	"./brands/cc-apple-pay.svg": [
		45667,
		45667
	],
	"./brands/cc-diners-club.svg": [
		45731,
		45731
	],
	"./brands/cc-discover.svg": [
		54722,
		54722
	],
	"./brands/cc-jcb.svg": [
		970,
		970
	],
	"./brands/cc-mastercard.svg": [
		47559,
		47559
	],
	"./brands/cc-paypal.svg": [
		3594,
		3594
	],
	"./brands/cc-stripe.svg": [
		24840,
		24840
	],
	"./brands/cc-visa.svg": [
		57590,
		57590
	],
	"./brands/centercode.svg": [
		71261,
		71261
	],
	"./brands/centos.svg": [
		50263,
		50263
	],
	"./brands/chrome.svg": [
		95566,
		95566
	],
	"./brands/chromecast.svg": [
		19140,
		19140
	],
	"./brands/cloudflare.svg": [
		34128,
		34128
	],
	"./brands/cloudscale.svg": [
		5755,
		5755
	],
	"./brands/cloudsmith.svg": [
		29213,
		29213
	],
	"./brands/cloudversify.svg": [
		11187,
		11187
	],
	"./brands/cmplid.svg": [
		98896,
		98896
	],
	"./brands/codepen.svg": [
		61645,
		61645
	],
	"./brands/codiepie.svg": [
		90977,
		90977
	],
	"./brands/confluence.svg": [
		89802,
		89802
	],
	"./brands/connectdevelop.svg": [
		70383,
		70383
	],
	"./brands/contao.svg": [
		28410,
		28410
	],
	"./brands/cotton-bureau.svg": [
		89505,
		89505
	],
	"./brands/cpanel.svg": [
		57582,
		57582
	],
	"./brands/creative-commons-by.svg": [
		78872,
		78872
	],
	"./brands/creative-commons-nc-eu.svg": [
		27128,
		27128
	],
	"./brands/creative-commons-nc-jp.svg": [
		43999,
		43999
	],
	"./brands/creative-commons-nc.svg": [
		15582,
		15582
	],
	"./brands/creative-commons-nd.svg": [
		17,
		17
	],
	"./brands/creative-commons-pd-alt.svg": [
		47089,
		47089
	],
	"./brands/creative-commons-pd.svg": [
		52391,
		52391
	],
	"./brands/creative-commons-remix.svg": [
		83379,
		83379
	],
	"./brands/creative-commons-sa.svg": [
		76574,
		76574
	],
	"./brands/creative-commons-sampling-plus.svg": [
		714,
		714
	],
	"./brands/creative-commons-sampling.svg": [
		31747,
		31747
	],
	"./brands/creative-commons-share.svg": [
		4519,
		4519
	],
	"./brands/creative-commons-zero.svg": [
		2247,
		2247
	],
	"./brands/creative-commons.svg": [
		85963,
		85963
	],
	"./brands/critical-role.svg": [
		95780,
		95780
	],
	"./brands/css3-alt.svg": [
		58683,
		58683
	],
	"./brands/css3.svg": [
		17812,
		17812
	],
	"./brands/cuttlefish.svg": [
		39434,
		39434
	],
	"./brands/d-and-d-beyond.svg": [
		28352,
		28352
	],
	"./brands/d-and-d.svg": [
		87210,
		87210
	],
	"./brands/dailymotion.svg": [
		29630,
		29630
	],
	"./brands/dashcube.svg": [
		67915,
		67915
	],
	"./brands/deezer.svg": [
		87793,
		87793
	],
	"./brands/delicious.svg": [
		60638,
		60638
	],
	"./brands/deploydog.svg": [
		26389,
		26389
	],
	"./brands/deskpro.svg": [
		73283,
		73283
	],
	"./brands/dev.svg": [
		59682,
		59682
	],
	"./brands/deviantart.svg": [
		75050,
		75050
	],
	"./brands/dhl.svg": [
		65913,
		65913
	],
	"./brands/diaspora.svg": [
		62951,
		62951
	],
	"./brands/digg.svg": [
		70134,
		70134
	],
	"./brands/digital-ocean.svg": [
		27441,
		27441
	],
	"./brands/discord.svg": [
		74390,
		74390
	],
	"./brands/discourse.svg": [
		34995,
		34995
	],
	"./brands/dochub.svg": [
		29117,
		29117
	],
	"./brands/docker.svg": [
		40569,
		40569
	],
	"./brands/draft2digital.svg": [
		62693,
		62693
	],
	"./brands/dribbble.svg": [
		81056,
		81056
	],
	"./brands/dropbox.svg": [
		84271,
		84271
	],
	"./brands/drupal.svg": [
		77688,
		77688
	],
	"./brands/dyalog.svg": [
		5662,
		5662
	],
	"./brands/earlybirds.svg": [
		99341,
		99341
	],
	"./brands/ebay.svg": [
		66215,
		66215
	],
	"./brands/edge-legacy.svg": [
		34366,
		34366
	],
	"./brands/edge.svg": [
		53908,
		53908
	],
	"./brands/elementor.svg": [
		95994,
		95994
	],
	"./brands/ello.svg": [
		93011,
		93011
	],
	"./brands/ember.svg": [
		16563,
		16563
	],
	"./brands/empire.svg": [
		66956,
		94663
	],
	"./brands/envira.svg": [
		28283,
		28283
	],
	"./brands/erlang.svg": [
		24316,
		24316
	],
	"./brands/ethereum.svg": [
		59346,
		59346
	],
	"./brands/etsy.svg": [
		24023,
		24023
	],
	"./brands/evernote.svg": [
		14260,
		14260
	],
	"./brands/expeditedssl.svg": [
		80731,
		80731
	],
	"./brands/facebook-f.svg": [
		20535,
		20535
	],
	"./brands/facebook-messenger.svg": [
		86249,
		86249
	],
	"./brands/facebook.svg": [
		97780,
		97780
	],
	"./brands/fantasy-flight-games.svg": [
		32037,
		32037
	],
	"./brands/fedex.svg": [
		83064,
		83064
	],
	"./brands/fedora.svg": [
		49390,
		78006
	],
	"./brands/figma.svg": [
		42891,
		42891
	],
	"./brands/firefox-browser.svg": [
		66125,
		66125
	],
	"./brands/firefox.svg": [
		81947,
		81947
	],
	"./brands/first-order-alt.svg": [
		39037,
		39037
	],
	"./brands/first-order.svg": [
		82279,
		82279
	],
	"./brands/firstdraft.svg": [
		74095,
		74095
	],
	"./brands/flickr.svg": [
		20454,
		20454
	],
	"./brands/flipboard.svg": [
		34647,
		34647
	],
	"./brands/fly.svg": [
		2599,
		2599
	],
	"./brands/font-awesome.svg": [
		79677,
		79677
	],
	"./brands/fonticons-fi.svg": [
		39591,
		39591
	],
	"./brands/fonticons.svg": [
		43819,
		43819
	],
	"./brands/fort-awesome-alt.svg": [
		4259,
		4259
	],
	"./brands/fort-awesome.svg": [
		90752,
		90752
	],
	"./brands/forumbee.svg": [
		91897,
		91897
	],
	"./brands/foursquare.svg": [
		86542,
		86542
	],
	"./brands/free-code-camp.svg": [
		39809,
		39809
	],
	"./brands/freebsd.svg": [
		35422,
		35422
	],
	"./brands/fulcrum.svg": [
		50467,
		50467
	],
	"./brands/galactic-republic.svg": [
		71837,
		71837
	],
	"./brands/galactic-senate.svg": [
		79622,
		79622
	],
	"./brands/get-pocket.svg": [
		56835,
		56835
	],
	"./brands/gg-circle.svg": [
		44080,
		44080
	],
	"./brands/gg.svg": [
		9441,
		9441
	],
	"./brands/git-alt.svg": [
		67201,
		67201
	],
	"./brands/git.svg": [
		27680,
		27680
	],
	"./brands/github-alt.svg": [
		40915,
		40915
	],
	"./brands/github.svg": [
		88954,
		88954
	],
	"./brands/gitkraken.svg": [
		40965,
		40965
	],
	"./brands/gitlab.svg": [
		47307,
		47307
	],
	"./brands/gitter.svg": [
		12208,
		12208
	],
	"./brands/glide-g.svg": [
		54142,
		54142
	],
	"./brands/glide.svg": [
		14303,
		14303
	],
	"./brands/gofore.svg": [
		25965,
		25965
	],
	"./brands/golang.svg": [
		89083,
		89083
	],
	"./brands/goodreads-g.svg": [
		15532,
		15532
	],
	"./brands/goodreads.svg": [
		25223,
		25223
	],
	"./brands/google-drive.svg": [
		73587,
		73587
	],
	"./brands/google-pay.svg": [
		27256,
		27256
	],
	"./brands/google-play.svg": [
		10428,
		10428
	],
	"./brands/google-plus-g.svg": [
		85578,
		85578
	],
	"./brands/google-plus.svg": [
		56666,
		56666
	],
	"./brands/google-wallet.svg": [
		19958,
		19958
	],
	"./brands/google.svg": [
		48191,
		48191
	],
	"./brands/gratipay.svg": [
		22606,
		22606
	],
	"./brands/grav.svg": [
		34115,
		34115
	],
	"./brands/gripfire.svg": [
		76163,
		76163
	],
	"./brands/grunt.svg": [
		10654,
		10654
	],
	"./brands/guilded.svg": [
		86333,
		86333
	],
	"./brands/gulp.svg": [
		96023,
		96023
	],
	"./brands/hacker-news.svg": [
		96380,
		96380
	],
	"./brands/hackerrank.svg": [
		20258,
		20258
	],
	"./brands/hashnode.svg": [
		98919,
		98919
	],
	"./brands/hips.svg": [
		98176,
		98176
	],
	"./brands/hire-a-helper.svg": [
		1965,
		1965
	],
	"./brands/hive.svg": [
		27484,
		27484
	],
	"./brands/hooli.svg": [
		55130,
		55130
	],
	"./brands/hornbill.svg": [
		65395,
		65395
	],
	"./brands/hotjar.svg": [
		50718,
		50718
	],
	"./brands/houzz.svg": [
		90484,
		90484
	],
	"./brands/html5.svg": [
		39630,
		39630
	],
	"./brands/hubspot.svg": [
		58265,
		58265
	],
	"./brands/ideal.svg": [
		84786,
		84786
	],
	"./brands/imdb.svg": [
		71974,
		71974
	],
	"./brands/instagram.svg": [
		15370,
		15370
	],
	"./brands/instalod.svg": [
		2271,
		2271
	],
	"./brands/intercom.svg": [
		62300,
		62300
	],
	"./brands/internet-explorer.svg": [
		13253,
		13253
	],
	"./brands/invision.svg": [
		45598,
		45598
	],
	"./brands/ioxhost.svg": [
		20189,
		20189
	],
	"./brands/itch-io.svg": [
		67161,
		67161
	],
	"./brands/itunes-note.svg": [
		20607,
		20607
	],
	"./brands/itunes.svg": [
		13652,
		13652
	],
	"./brands/java.svg": [
		3714,
		3714
	],
	"./brands/jedi-order.svg": [
		31493,
		31493
	],
	"./brands/jenkins.svg": [
		27445,
		27445
	],
	"./brands/jira.svg": [
		36668,
		36668
	],
	"./brands/joget.svg": [
		58339,
		58339
	],
	"./brands/joomla.svg": [
		69764,
		69764
	],
	"./brands/js.svg": [
		11215,
		11215
	],
	"./brands/jsfiddle.svg": [
		4738,
		4738
	],
	"./brands/kaggle.svg": [
		17059,
		17059
	],
	"./brands/keybase.svg": [
		58614,
		58614
	],
	"./brands/keycdn.svg": [
		31071,
		31071
	],
	"./brands/kickstarter-k.svg": [
		91402,
		91402
	],
	"./brands/kickstarter.svg": [
		84197,
		84197
	],
	"./brands/korvue.svg": [
		24826,
		24826
	],
	"./brands/laravel.svg": [
		49851,
		49851
	],
	"./brands/lastfm.svg": [
		49452,
		49452
	],
	"./brands/leanpub.svg": [
		11167,
		11167
	],
	"./brands/less.svg": [
		65215,
		65215
	],
	"./brands/line.svg": [
		71124,
		71124
	],
	"./brands/linkedin-in.svg": [
		27591,
		27591
	],
	"./brands/linkedin.svg": [
		49811,
		49811
	],
	"./brands/linode.svg": [
		63594,
		63594
	],
	"./brands/linux.svg": [
		68943,
		68943
	],
	"./brands/lyft.svg": [
		59243,
		59243
	],
	"./brands/magento.svg": [
		71191,
		71191
	],
	"./brands/mailchimp.svg": [
		2816,
		2816
	],
	"./brands/mandalorian.svg": [
		43648,
		43648
	],
	"./brands/markdown.svg": [
		68223,
		68223
	],
	"./brands/mastodon.svg": [
		4647,
		4647
	],
	"./brands/maxcdn.svg": [
		42218,
		42218
	],
	"./brands/mdb.svg": [
		87698,
		87698
	],
	"./brands/medapps.svg": [
		14592,
		14592
	],
	"./brands/medium.svg": [
		85015,
		85015
	],
	"./brands/medrt.svg": [
		62205,
		62205
	],
	"./brands/meetup.svg": [
		96002,
		96002
	],
	"./brands/megaport.svg": [
		27827,
		27827
	],
	"./brands/mendeley.svg": [
		22728,
		22728
	],
	"./brands/meta.svg": [
		71852,
		71852
	],
	"./brands/microblog.svg": [
		71334,
		71334
	],
	"./brands/microsoft.svg": [
		230,
		230
	],
	"./brands/mix.svg": [
		91061,
		91061
	],
	"./brands/mixcloud.svg": [
		56914,
		56914
	],
	"./brands/mixer.svg": [
		9802,
		9802
	],
	"./brands/mizuni.svg": [
		65696,
		65696
	],
	"./brands/modx.svg": [
		49696,
		49696
	],
	"./brands/monero.svg": [
		57745,
		18319
	],
	"./brands/napster.svg": [
		17128,
		17128
	],
	"./brands/neos.svg": [
		69888,
		69888
	],
	"./brands/nfc-directional.svg": [
		83493,
		83493
	],
	"./brands/nfc-symbol.svg": [
		97768,
		97768
	],
	"./brands/nimblr.svg": [
		38864,
		38864
	],
	"./brands/node-js.svg": [
		51511,
		51511
	],
	"./brands/node.svg": [
		94735,
		94735
	],
	"./brands/npm.svg": [
		82633,
		82633
	],
	"./brands/ns8.svg": [
		16269,
		16269
	],
	"./brands/nutritionix.svg": [
		15343,
		15343
	],
	"./brands/octopus-deploy.svg": [
		15291,
		15291
	],
	"./brands/odnoklassniki.svg": [
		86417,
		86417
	],
	"./brands/odysee.svg": [
		62527,
		62527
	],
	"./brands/old-republic.svg": [
		8822,
		8822
	],
	"./brands/opencart.svg": [
		39901,
		39901
	],
	"./brands/openid.svg": [
		9609,
		9609
	],
	"./brands/opera.svg": [
		39490,
		39490
	],
	"./brands/optin-monster.svg": [
		98163,
		98163
	],
	"./brands/orcid.svg": [
		34997,
		34997
	],
	"./brands/osi.svg": [
		72554,
		72554
	],
	"./brands/padlet.svg": [
		25404,
		25404
	],
	"./brands/page4.svg": [
		37885,
		37885
	],
	"./brands/pagelines.svg": [
		32019,
		32019
	],
	"./brands/palfed.svg": [
		76606,
		76606
	],
	"./brands/patreon.svg": [
		5720,
		5720
	],
	"./brands/paypal.svg": [
		63920,
		63920
	],
	"./brands/perbyte.svg": [
		6186,
		6186
	],
	"./brands/periscope.svg": [
		42026,
		42026
	],
	"./brands/phabricator.svg": [
		79942,
		79942
	],
	"./brands/phoenix-framework.svg": [
		3505,
		3505
	],
	"./brands/phoenix-squadron.svg": [
		37538,
		37538
	],
	"./brands/php.svg": [
		28115,
		28115
	],
	"./brands/pied-piper-alt.svg": [
		15397,
		15397
	],
	"./brands/pied-piper-hat.svg": [
		41212,
		41212
	],
	"./brands/pied-piper-pp.svg": [
		34763,
		34763
	],
	"./brands/pied-piper.svg": [
		82434,
		82434
	],
	"./brands/pinterest-p.svg": [
		80197,
		80197
	],
	"./brands/pinterest.svg": [
		52439,
		52439
	],
	"./brands/pix.svg": [
		63030,
		63030
	],
	"./brands/playstation.svg": [
		93961,
		93961
	],
	"./brands/product-hunt.svg": [
		75195,
		75195
	],
	"./brands/pushed.svg": [
		72887,
		72887
	],
	"./brands/python.svg": [
		96167,
		96167
	],
	"./brands/qq.svg": [
		82181,
		82181
	],
	"./brands/quinscape.svg": [
		81387,
		81387
	],
	"./brands/quora.svg": [
		72549,
		72549
	],
	"./brands/r-project.svg": [
		44114,
		44114
	],
	"./brands/raspberry-pi.svg": [
		78835,
		78835
	],
	"./brands/ravelry.svg": [
		80347,
		80347
	],
	"./brands/react.svg": [
		40898,
		40898
	],
	"./brands/reacteurope.svg": [
		96532,
		96532
	],
	"./brands/readme.svg": [
		72200,
		72200
	],
	"./brands/rebel.svg": [
		60540,
		60540
	],
	"./brands/red-river.svg": [
		18208,
		18208
	],
	"./brands/reddit-alien.svg": [
		80932,
		95390
	],
	"./brands/reddit.svg": [
		1391,
		1391
	],
	"./brands/redhat.svg": [
		87254,
		87254
	],
	"./brands/renren.svg": [
		22605,
		22605
	],
	"./brands/replyd.svg": [
		89032,
		89032
	],
	"./brands/researchgate.svg": [
		2541,
		2541
	],
	"./brands/resolving.svg": [
		5659,
		27975
	],
	"./brands/rev.svg": [
		71787,
		71787
	],
	"./brands/rocketchat.svg": [
		60300,
		60300
	],
	"./brands/rockrms.svg": [
		41117,
		41117
	],
	"./brands/rust.svg": [
		32078,
		32078
	],
	"./brands/safari.svg": [
		51621,
		51621
	],
	"./brands/salesforce.svg": [
		54696,
		54696
	],
	"./brands/sass.svg": [
		32609,
		32609
	],
	"./brands/schlix.svg": [
		7195,
		7195
	],
	"./brands/screenpal.svg": [
		55956,
		55956
	],
	"./brands/scribd.svg": [
		61996,
		61996
	],
	"./brands/searchengin.svg": [
		61757,
		61757
	],
	"./brands/sellcast.svg": [
		27489,
		27489
	],
	"./brands/sellsy.svg": [
		19133,
		19133
	],
	"./brands/servicestack.svg": [
		22092,
		22092
	],
	"./brands/shirtsinbulk.svg": [
		10471,
		10471
	],
	"./brands/shopify.svg": [
		79644,
		79644
	],
	"./brands/shopware.svg": [
		50799,
		50799
	],
	"./brands/simplybuilt.svg": [
		70229,
		70229
	],
	"./brands/sistrix.svg": [
		59552,
		59552
	],
	"./brands/sith.svg": [
		26482,
		26482
	],
	"./brands/sitrox.svg": [
		90353,
		90353
	],
	"./brands/sketch.svg": [
		63232,
		63232
	],
	"./brands/skyatlas.svg": [
		28322,
		28322
	],
	"./brands/skype.svg": [
		81468,
		81468
	],
	"./brands/slack.svg": [
		20510,
		20510
	],
	"./brands/slideshare.svg": [
		74276,
		74276
	],
	"./brands/snapchat.svg": [
		65250,
		65250
	],
	"./brands/soundcloud.svg": [
		86841,
		86841
	],
	"./brands/sourcetree.svg": [
		10652,
		10652
	],
	"./brands/space-awesome.svg": [
		41447,
		41447
	],
	"./brands/speakap.svg": [
		34738,
		34738
	],
	"./brands/speaker-deck.svg": [
		69781,
		69781
	],
	"./brands/spotify.svg": [
		46805,
		46805
	],
	"./brands/square-behance.svg": [
		34806,
		57745
	],
	"./brands/square-dribbble.svg": [
		25728,
		25728
	],
	"./brands/square-facebook.svg": [
		34788,
		34788
	],
	"./brands/square-font-awesome-stroke.svg": [
		6689,
		6689
	],
	"./brands/square-font-awesome.svg": [
		62012,
		62012
	],
	"./brands/square-git.svg": [
		5449,
		5449
	],
	"./brands/square-github.svg": [
		15558,
		15558
	],
	"./brands/square-gitlab.svg": [
		49536,
		49536
	],
	"./brands/square-google-plus.svg": [
		91325,
		91325
	],
	"./brands/square-hacker-news.svg": [
		47874,
		47874
	],
	"./brands/square-instagram.svg": [
		22920,
		22920
	],
	"./brands/square-js.svg": [
		76555,
		76555
	],
	"./brands/square-lastfm.svg": [
		56159,
		56159
	],
	"./brands/square-odnoklassniki.svg": [
		82817,
		82817
	],
	"./brands/square-pied-piper.svg": [
		2963,
		2963
	],
	"./brands/square-pinterest.svg": [
		66507,
		66507
	],
	"./brands/square-reddit.svg": [
		14398,
		14398
	],
	"./brands/square-snapchat.svg": [
		35117,
		35117
	],
	"./brands/square-steam.svg": [
		33027,
		33027
	],
	"./brands/square-tumblr.svg": [
		9781,
		9781
	],
	"./brands/square-twitter.svg": [
		64619,
		64619
	],
	"./brands/square-viadeo.svg": [
		14394,
		14394
	],
	"./brands/square-vimeo.svg": [
		45150,
		45150
	],
	"./brands/square-whatsapp.svg": [
		90334,
		90334
	],
	"./brands/square-xing.svg": [
		2218,
		2218
	],
	"./brands/square-youtube.svg": [
		53407,
		53407
	],
	"./brands/squarespace.svg": [
		23226,
		23226
	],
	"./brands/stack-exchange.svg": [
		55326,
		55326
	],
	"./brands/stack-overflow.svg": [
		77847,
		77847
	],
	"./brands/stackpath.svg": [
		68091,
		68091
	],
	"./brands/staylinked.svg": [
		5865,
		5865
	],
	"./brands/steam-symbol.svg": [
		83200,
		83200
	],
	"./brands/steam.svg": [
		36598,
		36598
	],
	"./brands/sticker-mule.svg": [
		64629,
		64629
	],
	"./brands/strava.svg": [
		28850,
		28850
	],
	"./brands/stripe-s.svg": [
		5591,
		5591
	],
	"./brands/stripe.svg": [
		34920,
		34920
	],
	"./brands/stubber.svg": [
		55097,
		55097
	],
	"./brands/studiovinari.svg": [
		22454,
		22454
	],
	"./brands/stumbleupon-circle.svg": [
		95869,
		95869
	],
	"./brands/stumbleupon.svg": [
		57880,
		57880
	],
	"./brands/superpowers.svg": [
		31397,
		31397
	],
	"./brands/supple.svg": [
		30303,
		30303
	],
	"./brands/suse.svg": [
		44888,
		44888
	],
	"./brands/swift.svg": [
		9216,
		9216
	],
	"./brands/symfony.svg": [
		11532,
		11532
	],
	"./brands/teamspeak.svg": [
		53240,
		53240
	],
	"./brands/telegram.svg": [
		55998,
		55998
	],
	"./brands/tencent-weibo.svg": [
		98999,
		98999
	],
	"./brands/the-red-yeti.svg": [
		39854,
		39854
	],
	"./brands/themeco.svg": [
		24886,
		24886
	],
	"./brands/themeisle.svg": [
		23027,
		23027
	],
	"./brands/think-peaks.svg": [
		81520,
		81520
	],
	"./brands/tiktok.svg": [
		60909,
		60909
	],
	"./brands/trade-federation.svg": [
		72240,
		72240
	],
	"./brands/trello.svg": [
		97787,
		97787
	],
	"./brands/tumblr.svg": [
		7211,
		7211
	],
	"./brands/twitch.svg": [
		43317,
		43317
	],
	"./brands/twitter.svg": [
		19042,
		19042
	],
	"./brands/typo3.svg": [
		90090,
		90090
	],
	"./brands/uber.svg": [
		80723,
		43371
	],
	"./brands/ubuntu.svg": [
		67855,
		67855
	],
	"./brands/uikit.svg": [
		582,
		582
	],
	"./brands/umbraco.svg": [
		35533,
		98535
	],
	"./brands/uncharted.svg": [
		95254,
		95254
	],
	"./brands/uniregistry.svg": [
		63216,
		63216
	],
	"./brands/unity.svg": [
		73694,
		73694
	],
	"./brands/unsplash.svg": [
		75681,
		75681
	],
	"./brands/untappd.svg": [
		12816,
		12816
	],
	"./brands/ups.svg": [
		49705,
		49705
	],
	"./brands/usb.svg": [
		34448,
		34448
	],
	"./brands/usps.svg": [
		53480,
		53480
	],
	"./brands/ussunnah.svg": [
		39797,
		39797
	],
	"./brands/vaadin.svg": [
		37185,
		37185
	],
	"./brands/viacoin.svg": [
		65685,
		65685
	],
	"./brands/viadeo.svg": [
		30886,
		59704
	],
	"./brands/viber.svg": [
		54864,
		54864
	],
	"./brands/vimeo-v.svg": [
		13871,
		13871
	],
	"./brands/vimeo.svg": [
		53875,
		53875
	],
	"./brands/vine.svg": [
		49482,
		49482
	],
	"./brands/vk.svg": [
		72423,
		72423
	],
	"./brands/vnv.svg": [
		17851,
		17851
	],
	"./brands/vuejs.svg": [
		81702,
		81702
	],
	"./brands/watchman-monitoring.svg": [
		70713,
		70713
	],
	"./brands/waze.svg": [
		91057,
		91057
	],
	"./brands/weebly.svg": [
		77503,
		77503
	],
	"./brands/weibo.svg": [
		95258,
		95258
	],
	"./brands/weixin.svg": [
		39788,
		39788
	],
	"./brands/whatsapp.svg": [
		46849,
		46849
	],
	"./brands/whmcs.svg": [
		82869,
		82869
	],
	"./brands/wikipedia-w.svg": [
		8718,
		8718
	],
	"./brands/windows.svg": [
		78751,
		78751
	],
	"./brands/wirsindhandwerk.svg": [
		81179,
		81179
	],
	"./brands/wix.svg": [
		63852,
		63852
	],
	"./brands/wizards-of-the-coast.svg": [
		88003,
		88003
	],
	"./brands/wodu.svg": [
		55691,
		55691
	],
	"./brands/wolf-pack-battalion.svg": [
		47471,
		47471
	],
	"./brands/wordpress-simple.svg": [
		69236,
		69236
	],
	"./brands/wordpress.svg": [
		72656,
		72656
	],
	"./brands/wpbeginner.svg": [
		96819,
		96819
	],
	"./brands/wpexplorer.svg": [
		5090,
		5090
	],
	"./brands/wpforms.svg": [
		47714,
		47714
	],
	"./brands/wpressr.svg": [
		75034,
		75034
	],
	"./brands/xbox.svg": [
		44088,
		44088
	],
	"./brands/xing.svg": [
		35307,
		35307
	],
	"./brands/y-combinator.svg": [
		57333,
		57333
	],
	"./brands/yahoo.svg": [
		67350,
		67350
	],
	"./brands/yammer.svg": [
		30613,
		30613
	],
	"./brands/yandex-international.svg": [
		65541,
		65541
	],
	"./brands/yandex.svg": [
		73760,
		73760
	],
	"./brands/yarn.svg": [
		54859,
		54859
	],
	"./brands/yelp.svg": [
		11948,
		11948
	],
	"./brands/yoast.svg": [
		61409,
		61409
	],
	"./brands/youtube.svg": [
		69591,
		69591
	],
	"./brands/zhihu.svg": [
		75447,
		75447
	],
	"./regular/address-book.svg": [
		54532,
		54532
	],
	"./regular/address-card.svg": [
		45707,
		45707
	],
	"./regular/bell-slash.svg": [
		96909,
		96909
	],
	"./regular/bell.svg": [
		15446,
		15446
	],
	"./regular/bookmark.svg": [
		61509,
		61509
	],
	"./regular/building.svg": [
		17147,
		17147
	],
	"./regular/calendar-check.svg": [
		78969,
		78969
	],
	"./regular/calendar-days.svg": [
		85324,
		85324
	],
	"./regular/calendar-minus.svg": [
		84282,
		84282
	],
	"./regular/calendar-plus.svg": [
		48375,
		48375
	],
	"./regular/calendar-xmark.svg": [
		13508,
		13508
	],
	"./regular/calendar.svg": [
		84251,
		84251
	],
	"./regular/chart-bar.svg": [
		82660,
		82660
	],
	"./regular/chess-bishop.svg": [
		98338,
		98338
	],
	"./regular/chess-king.svg": [
		10253,
		10253
	],
	"./regular/chess-knight.svg": [
		87446,
		87446
	],
	"./regular/chess-pawn.svg": [
		53615,
		53615
	],
	"./regular/chess-queen.svg": [
		3476,
		3476
	],
	"./regular/chess-rook.svg": [
		63720,
		63720
	],
	"./regular/circle-check.svg": [
		6903,
		6903
	],
	"./regular/circle-dot.svg": [
		76927,
		76927
	],
	"./regular/circle-down.svg": [
		8471,
		8471
	],
	"./regular/circle-left.svg": [
		82675,
		82675
	],
	"./regular/circle-pause.svg": [
		27102,
		67869
	],
	"./regular/circle-play.svg": [
		39192,
		39192
	],
	"./regular/circle-question.svg": [
		79406,
		79406
	],
	"./regular/circle-right.svg": [
		34287,
		49390
	],
	"./regular/circle-stop.svg": [
		23914,
		23914
	],
	"./regular/circle-up.svg": [
		49532,
		49532
	],
	"./regular/circle-user.svg": [
		48721,
		48721
	],
	"./regular/circle-xmark.svg": [
		99293,
		99293
	],
	"./regular/circle.svg": [
		80353,
		80353
	],
	"./regular/clipboard.svg": [
		24231,
		24231
	],
	"./regular/clock.svg": [
		97281,
		97281
	],
	"./regular/clone.svg": [
		14616,
		14616
	],
	"./regular/closed-captioning.svg": [
		29884,
		29884
	],
	"./regular/comment-dots.svg": [
		21448,
		21448
	],
	"./regular/comment.svg": [
		66441,
		66441
	],
	"./regular/comments.svg": [
		91298,
		91298
	],
	"./regular/compass.svg": [
		6787,
		6787
	],
	"./regular/copy.svg": [
		22799,
		22799
	],
	"./regular/copyright.svg": [
		95315,
		87346
	],
	"./regular/credit-card.svg": [
		23001,
		23001
	],
	"./regular/envelope-open.svg": [
		73472,
		73472
	],
	"./regular/envelope.svg": [
		11479,
		11479
	],
	"./regular/eye-slash.svg": [
		1213,
		1213
	],
	"./regular/eye.svg": [
		68151,
		68151
	],
	"./regular/face-angry.svg": [
		97571,
		97571
	],
	"./regular/face-dizzy.svg": [
		59844,
		59844
	],
	"./regular/face-flushed.svg": [
		80597,
		80597
	],
	"./regular/face-frown-open.svg": [
		72357,
		72357
	],
	"./regular/face-frown.svg": [
		79802,
		79802
	],
	"./regular/face-grimace.svg": [
		68196,
		68196
	],
	"./regular/face-grin-beam-sweat.svg": [
		33406,
		33406
	],
	"./regular/face-grin-beam.svg": [
		15355,
		15355
	],
	"./regular/face-grin-hearts.svg": [
		55350,
		55350
	],
	"./regular/face-grin-squint-tears.svg": [
		9874,
		9874
	],
	"./regular/face-grin-squint.svg": [
		85820,
		85820
	],
	"./regular/face-grin-stars.svg": [
		37639,
		37639
	],
	"./regular/face-grin-tears.svg": [
		65107,
		65107
	],
	"./regular/face-grin-tongue-squint.svg": [
		60082,
		60082
	],
	"./regular/face-grin-tongue-wink.svg": [
		24463,
		24463
	],
	"./regular/face-grin-tongue.svg": [
		45281,
		45281
	],
	"./regular/face-grin-wide.svg": [
		46644,
		46644
	],
	"./regular/face-grin-wink.svg": [
		25389,
		25389
	],
	"./regular/face-grin.svg": [
		33378,
		33378
	],
	"./regular/face-kiss-beam.svg": [
		91102,
		91102
	],
	"./regular/face-kiss-wink-heart.svg": [
		90990,
		90990
	],
	"./regular/face-kiss.svg": [
		63198,
		63198
	],
	"./regular/face-laugh-beam.svg": [
		76219,
		76219
	],
	"./regular/face-laugh-squint.svg": [
		22043,
		22043
	],
	"./regular/face-laugh-wink.svg": [
		75888,
		75888
	],
	"./regular/face-laugh.svg": [
		58940,
		58940
	],
	"./regular/face-meh-blank.svg": [
		90829,
		90829
	],
	"./regular/face-meh.svg": [
		83315,
		83315
	],
	"./regular/face-rolling-eyes.svg": [
		47908,
		47908
	],
	"./regular/face-sad-cry.svg": [
		65110,
		65110
	],
	"./regular/face-sad-tear.svg": [
		10954,
		10954
	],
	"./regular/face-smile-beam.svg": [
		17158,
		17158
	],
	"./regular/face-smile-wink.svg": [
		42944,
		42944
	],
	"./regular/face-smile.svg": [
		58195,
		58195
	],
	"./regular/face-surprise.svg": [
		44837,
		44837
	],
	"./regular/face-tired.svg": [
		92038,
		92038
	],
	"./regular/file-audio.svg": [
		65798,
		65798
	],
	"./regular/file-code.svg": [
		5341,
		5341
	],
	"./regular/file-excel.svg": [
		28299,
		28299
	],
	"./regular/file-image.svg": [
		96154,
		96154
	],
	"./regular/file-lines.svg": [
		64329,
		64329
	],
	"./regular/file-pdf.svg": [
		27003,
		27003
	],
	"./regular/file-powerpoint.svg": [
		44687,
		44687
	],
	"./regular/file-video.svg": [
		30113,
		30113
	],
	"./regular/file-word.svg": [
		42034,
		42034
	],
	"./regular/file-zipper.svg": [
		61691,
		61691
	],
	"./regular/file.svg": [
		26761,
		26761
	],
	"./regular/flag.svg": [
		51698,
		51698
	],
	"./regular/floppy-disk.svg": [
		30944,
		69782
	],
	"./regular/folder-closed.svg": [
		61719,
		61719
	],
	"./regular/folder-open.svg": [
		55827,
		67359
	],
	"./regular/folder.svg": [
		8767,
		8767
	],
	"./regular/font-awesome.svg": [
		32132,
		32132
	],
	"./regular/futbol.svg": [
		63066,
		63066
	],
	"./regular/gem.svg": [
		36595,
		36595
	],
	"./regular/hand-back-fist.svg": [
		78309,
		78309
	],
	"./regular/hand-lizard.svg": [
		38465,
		38465
	],
	"./regular/hand-peace.svg": [
		58132,
		58132
	],
	"./regular/hand-point-down.svg": [
		94789,
		94789
	],
	"./regular/hand-point-left.svg": [
		51762,
		51762
	],
	"./regular/hand-point-right.svg": [
		2332,
		2332
	],
	"./regular/hand-point-up.svg": [
		44808,
		44808
	],
	"./regular/hand-pointer.svg": [
		18558,
		18558
	],
	"./regular/hand-scissors.svg": [
		41328,
		41328
	],
	"./regular/hand-spock.svg": [
		78017,
		78017
	],
	"./regular/hand.svg": [
		66254,
		66254
	],
	"./regular/handshake.svg": [
		50876,
		50876
	],
	"./regular/hard-drive.svg": [
		66879,
		66879
	],
	"./regular/heart.svg": [
		74662,
		74662
	],
	"./regular/hospital.svg": [
		49949,
		49949
	],
	"./regular/hourglass-half.svg": [
		2572,
		2572
	],
	"./regular/hourglass.svg": [
		93567,
		93567
	],
	"./regular/id-badge.svg": [
		81754,
		81754
	],
	"./regular/id-card.svg": [
		36301,
		36301
	],
	"./regular/image.svg": [
		21020,
		21020
	],
	"./regular/images.svg": [
		71040,
		71040
	],
	"./regular/keyboard.svg": [
		62340,
		62340
	],
	"./regular/lemon.svg": [
		89325,
		89325
	],
	"./regular/life-ring.svg": [
		43104,
		43104
	],
	"./regular/lightbulb.svg": [
		47867,
		47867
	],
	"./regular/map.svg": [
		46324,
		46324
	],
	"./regular/message.svg": [
		41954,
		41954
	],
	"./regular/money-bill-1.svg": [
		37030,
		37030
	],
	"./regular/moon.svg": [
		52665,
		52665
	],
	"./regular/newspaper.svg": [
		6624,
		6624
	],
	"./regular/note-sticky.svg": [
		26708,
		26708
	],
	"./regular/object-group.svg": [
		48054,
		48054
	],
	"./regular/object-ungroup.svg": [
		51469,
		51469
	],
	"./regular/paper-plane.svg": [
		83187,
		83187
	],
	"./regular/paste.svg": [
		119,
		119
	],
	"./regular/pen-to-square.svg": [
		70926,
		70926
	],
	"./regular/rectangle-list.svg": [
		48975,
		48975
	],
	"./regular/rectangle-xmark.svg": [
		33166,
		33166
	],
	"./regular/registered.svg": [
		68749,
		68749
	],
	"./regular/share-from-square.svg": [
		17982,
		17982
	],
	"./regular/snowflake.svg": [
		42986,
		42986
	],
	"./regular/square-caret-down.svg": [
		30729,
		30729
	],
	"./regular/square-caret-left.svg": [
		68044,
		68044
	],
	"./regular/square-caret-right.svg": [
		25450,
		25450
	],
	"./regular/square-caret-up.svg": [
		79978,
		79978
	],
	"./regular/square-check.svg": [
		74502,
		74502
	],
	"./regular/square-full.svg": [
		90028,
		90028
	],
	"./regular/square-minus.svg": [
		67103,
		67103
	],
	"./regular/square-plus.svg": [
		23682,
		23682
	],
	"./regular/square.svg": [
		69215,
		69215
	],
	"./regular/star-half-stroke.svg": [
		44773,
		44773
	],
	"./regular/star-half.svg": [
		52927,
		52927
	],
	"./regular/star.svg": [
		539,
		539
	],
	"./regular/sun.svg": [
		79450,
		79450
	],
	"./regular/thumbs-down.svg": [
		72191,
		72191
	],
	"./regular/thumbs-up.svg": [
		21098,
		21098
	],
	"./regular/trash-can.svg": [
		28735,
		28735
	],
	"./regular/user.svg": [
		81022,
		81022
	],
	"./regular/window-maximize.svg": [
		6991,
		6991
	],
	"./regular/window-minimize.svg": [
		49371,
		49371
	],
	"./regular/window-restore.svg": [
		70947,
		70947
	],
	"./solid/0.svg": [
		94415,
		94415
	],
	"./solid/1.svg": [
		42480,
		42480
	],
	"./solid/2.svg": [
		47456,
		47456
	],
	"./solid/3.svg": [
		14428,
		14428
	],
	"./solid/4.svg": [
		10357,
		10357
	],
	"./solid/5.svg": [
		33483,
		33483
	],
	"./solid/6.svg": [
		39918,
		39918
	],
	"./solid/7.svg": [
		81483,
		81483
	],
	"./solid/8.svg": [
		14032,
		14032
	],
	"./solid/9.svg": [
		58510,
		58510
	],
	"./solid/a.svg": [
		71521,
		71521
	],
	"./solid/address-book.svg": [
		54596,
		48342
	],
	"./solid/address-card.svg": [
		11140,
		11140
	],
	"./solid/align-center.svg": [
		20296,
		20296
	],
	"./solid/align-justify.svg": [
		18507,
		18507
	],
	"./solid/align-left.svg": [
		1677,
		1677
	],
	"./solid/align-right.svg": [
		25675,
		25675
	],
	"./solid/anchor-circle-check.svg": [
		13166,
		13166
	],
	"./solid/anchor-circle-exclamation.svg": [
		14147,
		14147
	],
	"./solid/anchor-circle-xmark.svg": [
		22013,
		22013
	],
	"./solid/anchor-lock.svg": [
		3074,
		3074
	],
	"./solid/anchor.svg": [
		52708,
		52708
	],
	"./solid/angle-down.svg": [
		57435,
		57435
	],
	"./solid/angle-left.svg": [
		40739,
		40739
	],
	"./solid/angle-right.svg": [
		7505,
		7505
	],
	"./solid/angle-up.svg": [
		96009,
		96009
	],
	"./solid/angles-down.svg": [
		21429,
		21429
	],
	"./solid/angles-left.svg": [
		70113,
		70113
	],
	"./solid/angles-right.svg": [
		14262,
		14262
	],
	"./solid/angles-up.svg": [
		14170,
		14170
	],
	"./solid/ankh.svg": [
		88696,
		88696
	],
	"./solid/apple-whole.svg": [
		27594,
		27594
	],
	"./solid/archway.svg": [
		31696,
		31696
	],
	"./solid/arrow-down-1-9.svg": [
		91840,
		91840
	],
	"./solid/arrow-down-9-1.svg": [
		60977,
		60977
	],
	"./solid/arrow-down-a-z.svg": [
		10593,
		10593
	],
	"./solid/arrow-down-long.svg": [
		42260,
		42260
	],
	"./solid/arrow-down-short-wide.svg": [
		95520,
		95520
	],
	"./solid/arrow-down-up-across-line.svg": [
		63873,
		63873
	],
	"./solid/arrow-down-up-lock.svg": [
		95587,
		95587
	],
	"./solid/arrow-down-wide-short.svg": [
		29576,
		29576
	],
	"./solid/arrow-down-z-a.svg": [
		93675,
		93675
	],
	"./solid/arrow-down.svg": [
		89542,
		89542
	],
	"./solid/arrow-left-long.svg": [
		75670,
		75670
	],
	"./solid/arrow-left.svg": [
		4961,
		4961
	],
	"./solid/arrow-pointer.svg": [
		91596,
		91596
	],
	"./solid/arrow-right-arrow-left.svg": [
		12680,
		12680
	],
	"./solid/arrow-right-from-bracket.svg": [
		63525,
		63525
	],
	"./solid/arrow-right-long.svg": [
		58701,
		58701
	],
	"./solid/arrow-right-to-bracket.svg": [
		25016,
		25016
	],
	"./solid/arrow-right-to-city.svg": [
		73306,
		73306
	],
	"./solid/arrow-right.svg": [
		31653,
		31653
	],
	"./solid/arrow-rotate-left.svg": [
		38795,
		38795
	],
	"./solid/arrow-rotate-right.svg": [
		12851,
		12851
	],
	"./solid/arrow-trend-down.svg": [
		75021,
		75021
	],
	"./solid/arrow-trend-up.svg": [
		83238,
		83238
	],
	"./solid/arrow-turn-down.svg": [
		17699,
		17699
	],
	"./solid/arrow-turn-up.svg": [
		72234,
		72234
	],
	"./solid/arrow-up-1-9.svg": [
		86629,
		86629
	],
	"./solid/arrow-up-9-1.svg": [
		45806,
		45806
	],
	"./solid/arrow-up-a-z.svg": [
		66689,
		66689
	],
	"./solid/arrow-up-from-bracket.svg": [
		40134,
		40134
	],
	"./solid/arrow-up-from-ground-water.svg": [
		94772,
		94772
	],
	"./solid/arrow-up-from-water-pump.svg": [
		12457,
		12457
	],
	"./solid/arrow-up-long.svg": [
		91698,
		91698
	],
	"./solid/arrow-up-right-dots.svg": [
		96054,
		96054
	],
	"./solid/arrow-up-right-from-square.svg": [
		74505,
		74505
	],
	"./solid/arrow-up-short-wide.svg": [
		41839,
		41839
	],
	"./solid/arrow-up-wide-short.svg": [
		79524,
		79524
	],
	"./solid/arrow-up-z-a.svg": [
		10446,
		10446
	],
	"./solid/arrow-up.svg": [
		57112,
		57112
	],
	"./solid/arrows-down-to-line.svg": [
		57355,
		57355
	],
	"./solid/arrows-down-to-people.svg": [
		66050,
		66050
	],
	"./solid/arrows-left-right-to-line.svg": [
		13204,
		13204
	],
	"./solid/arrows-left-right.svg": [
		94378,
		94378
	],
	"./solid/arrows-rotate.svg": [
		38854,
		38854
	],
	"./solid/arrows-spin.svg": [
		51105,
		51105
	],
	"./solid/arrows-split-up-and-left.svg": [
		43110,
		73223
	],
	"./solid/arrows-to-circle.svg": [
		66882,
		66882
	],
	"./solid/arrows-to-dot.svg": [
		92401,
		92401
	],
	"./solid/arrows-to-eye.svg": [
		70451,
		70451
	],
	"./solid/arrows-turn-right.svg": [
		90321,
		90321
	],
	"./solid/arrows-turn-to-dots.svg": [
		99392,
		99392
	],
	"./solid/arrows-up-down-left-right.svg": [
		25527,
		25527
	],
	"./solid/arrows-up-down.svg": [
		53955,
		53955
	],
	"./solid/arrows-up-to-line.svg": [
		11734,
		11734
	],
	"./solid/asterisk.svg": [
		42853,
		42853
	],
	"./solid/at.svg": [
		90548,
		90548
	],
	"./solid/atom.svg": [
		2598,
		2598
	],
	"./solid/audio-description.svg": [
		74392,
		74392
	],
	"./solid/austral-sign.svg": [
		494,
		494
	],
	"./solid/award.svg": [
		55029,
		55029
	],
	"./solid/b.svg": [
		3115,
		3115
	],
	"./solid/baby-carriage.svg": [
		64245,
		75995
	],
	"./solid/baby.svg": [
		35488,
		35488
	],
	"./solid/backward-fast.svg": [
		24502,
		24502
	],
	"./solid/backward-step.svg": [
		9834,
		9834
	],
	"./solid/backward.svg": [
		4853,
		4853
	],
	"./solid/bacon.svg": [
		87894,
		87894
	],
	"./solid/bacteria.svg": [
		95643,
		95643
	],
	"./solid/bacterium.svg": [
		89821,
		89821
	],
	"./solid/bag-shopping.svg": [
		3509,
		3509
	],
	"./solid/bahai.svg": [
		47699,
		47699
	],
	"./solid/baht-sign.svg": [
		60808,
		60808
	],
	"./solid/ban-smoking.svg": [
		96213,
		96213
	],
	"./solid/ban.svg": [
		68045,
		68045
	],
	"./solid/bandage.svg": [
		76225,
		76225
	],
	"./solid/bangladeshi-taka-sign.svg": [
		1999,
		1999
	],
	"./solid/barcode.svg": [
		8930,
		8930
	],
	"./solid/bars-progress.svg": [
		71336,
		71336
	],
	"./solid/bars-staggered.svg": [
		5813,
		5813
	],
	"./solid/bars.svg": [
		26741,
		26741
	],
	"./solid/baseball-bat-ball.svg": [
		64998,
		64998
	],
	"./solid/baseball.svg": [
		24208,
		24208
	],
	"./solid/basket-shopping.svg": [
		53574,
		53574
	],
	"./solid/basketball.svg": [
		65762,
		65762
	],
	"./solid/bath.svg": [
		5906,
		5906
	],
	"./solid/battery-empty.svg": [
		74804,
		74804
	],
	"./solid/battery-full.svg": [
		75512,
		75512
	],
	"./solid/battery-half.svg": [
		13685,
		13685
	],
	"./solid/battery-quarter.svg": [
		25866,
		7020
	],
	"./solid/battery-three-quarters.svg": [
		82690,
		82690
	],
	"./solid/bed-pulse.svg": [
		31128,
		31128
	],
	"./solid/bed.svg": [
		36314,
		36314
	],
	"./solid/beer-mug-empty.svg": [
		52446,
		52446
	],
	"./solid/bell-concierge.svg": [
		48168,
		48168
	],
	"./solid/bell-slash.svg": [
		68366,
		68366
	],
	"./solid/bell.svg": [
		90704,
		90704
	],
	"./solid/bezier-curve.svg": [
		40482,
		75933
	],
	"./solid/bicycle.svg": [
		81487,
		81487
	],
	"./solid/binoculars.svg": [
		33756,
		33756
	],
	"./solid/biohazard.svg": [
		63308,
		63308
	],
	"./solid/bitcoin-sign.svg": [
		66817,
		66817
	],
	"./solid/blender-phone.svg": [
		80258,
		80258
	],
	"./solid/blender.svg": [
		14390,
		14390
	],
	"./solid/blog.svg": [
		71399,
		71399
	],
	"./solid/bold.svg": [
		44822,
		44822
	],
	"./solid/bolt-lightning.svg": [
		89568,
		89568
	],
	"./solid/bolt.svg": [
		25831,
		25831
	],
	"./solid/bomb.svg": [
		77914,
		77914
	],
	"./solid/bone.svg": [
		28800,
		28800
	],
	"./solid/bong.svg": [
		34376,
		34376
	],
	"./solid/book-atlas.svg": [
		18086,
		18086
	],
	"./solid/book-bible.svg": [
		51492,
		51492
	],
	"./solid/book-bookmark.svg": [
		77723,
		77723
	],
	"./solid/book-journal-whills.svg": [
		45094,
		45094
	],
	"./solid/book-medical.svg": [
		90447,
		90447
	],
	"./solid/book-open-reader.svg": [
		26122,
		26122
	],
	"./solid/book-open.svg": [
		98127,
		98127
	],
	"./solid/book-quran.svg": [
		92577,
		92577
	],
	"./solid/book-skull.svg": [
		3882,
		3882
	],
	"./solid/book-tanakh.svg": [
		58821,
		58821
	],
	"./solid/book.svg": [
		30308,
		30308
	],
	"./solid/bookmark.svg": [
		49553,
		49553
	],
	"./solid/border-all.svg": [
		86785,
		86785
	],
	"./solid/border-none.svg": [
		50491,
		50491
	],
	"./solid/border-top-left.svg": [
		17961,
		17961
	],
	"./solid/bore-hole.svg": [
		1607,
		1607
	],
	"./solid/bottle-droplet.svg": [
		87634,
		87634
	],
	"./solid/bottle-water.svg": [
		28047,
		28047
	],
	"./solid/bowl-food.svg": [
		27351,
		27351
	],
	"./solid/bowl-rice.svg": [
		14562,
		14562
	],
	"./solid/bowling-ball.svg": [
		17665,
		17665
	],
	"./solid/box-archive.svg": [
		54339,
		54339
	],
	"./solid/box-open.svg": [
		70264,
		70264
	],
	"./solid/box-tissue.svg": [
		68098,
		68098
	],
	"./solid/box.svg": [
		71873,
		71873
	],
	"./solid/boxes-packing.svg": [
		19606,
		19606
	],
	"./solid/boxes-stacked.svg": [
		83377,
		83377
	],
	"./solid/braille.svg": [
		54357,
		54357
	],
	"./solid/brain.svg": [
		63943,
		63943
	],
	"./solid/brazilian-real-sign.svg": [
		57314,
		57314
	],
	"./solid/bread-slice.svg": [
		43026,
		43026
	],
	"./solid/bridge-circle-check.svg": [
		65433,
		65433
	],
	"./solid/bridge-circle-exclamation.svg": [
		98210,
		98210
	],
	"./solid/bridge-circle-xmark.svg": [
		4631,
		4631
	],
	"./solid/bridge-lock.svg": [
		55905,
		30061
	],
	"./solid/bridge-water.svg": [
		60,
		60
	],
	"./solid/bridge.svg": [
		21144,
		21144
	],
	"./solid/briefcase-medical.svg": [
		80387,
		80387
	],
	"./solid/briefcase.svg": [
		30334,
		30334
	],
	"./solid/broom-ball.svg": [
		55490,
		55490
	],
	"./solid/broom.svg": [
		58846,
		58846
	],
	"./solid/brush.svg": [
		19050,
		19050
	],
	"./solid/bucket.svg": [
		12836,
		12836
	],
	"./solid/bug-slash.svg": [
		40174,
		55213
	],
	"./solid/bug.svg": [
		45764,
		45764
	],
	"./solid/bugs.svg": [
		8071,
		8071
	],
	"./solid/building-circle-arrow-right.svg": [
		22257,
		22257
	],
	"./solid/building-circle-check.svg": [
		54247,
		54247
	],
	"./solid/building-circle-exclamation.svg": [
		51353,
		51353
	],
	"./solid/building-circle-xmark.svg": [
		30591,
		30591
	],
	"./solid/building-columns.svg": [
		42046,
		42046
	],
	"./solid/building-flag.svg": [
		62700,
		62700
	],
	"./solid/building-lock.svg": [
		78524,
		78524
	],
	"./solid/building-ngo.svg": [
		63591,
		63591
	],
	"./solid/building-shield.svg": [
		96450,
		96450
	],
	"./solid/building-un.svg": [
		21119,
		21119
	],
	"./solid/building-user.svg": [
		74856,
		74856
	],
	"./solid/building-wheat.svg": [
		314,
		314
	],
	"./solid/building.svg": [
		62025,
		62025
	],
	"./solid/bullhorn.svg": [
		71907,
		14841
	],
	"./solid/bullseye.svg": [
		76313,
		76313
	],
	"./solid/burger.svg": [
		64282,
		64282
	],
	"./solid/burst.svg": [
		92304,
		92304
	],
	"./solid/bus-simple.svg": [
		24235,
		24235
	],
	"./solid/bus.svg": [
		33091,
		33091
	],
	"./solid/business-time.svg": [
		66546,
		66956
	],
	"./solid/c.svg": [
		42051,
		42051
	],
	"./solid/cable-car.svg": [
		35495,
		35495
	],
	"./solid/cake-candles.svg": [
		53244,
		53244
	],
	"./solid/calculator.svg": [
		7711,
		7711
	],
	"./solid/calendar-check.svg": [
		27997,
		27997
	],
	"./solid/calendar-day.svg": [
		64227,
		64227
	],
	"./solid/calendar-days.svg": [
		3654,
		3654
	],
	"./solid/calendar-minus.svg": [
		79529,
		79529
	],
	"./solid/calendar-plus.svg": [
		52976,
		52976
	],
	"./solid/calendar-week.svg": [
		37138,
		37138
	],
	"./solid/calendar-xmark.svg": [
		67372,
		67372
	],
	"./solid/calendar.svg": [
		86336,
		86336
	],
	"./solid/camera-retro.svg": [
		67084,
		67084
	],
	"./solid/camera-rotate.svg": [
		1906,
		1906
	],
	"./solid/camera.svg": [
		35826,
		35826
	],
	"./solid/campground.svg": [
		61464,
		61464
	],
	"./solid/candy-cane.svg": [
		22929,
		22929
	],
	"./solid/cannabis.svg": [
		76214,
		76214
	],
	"./solid/capsules.svg": [
		63662,
		63662
	],
	"./solid/car-battery.svg": [
		14053,
		14053
	],
	"./solid/car-burst.svg": [
		72925,
		72925
	],
	"./solid/car-on.svg": [
		22922,
		22922
	],
	"./solid/car-rear.svg": [
		45785,
		45785
	],
	"./solid/car-side.svg": [
		40830,
		40830
	],
	"./solid/car-tunnel.svg": [
		58815,
		58815
	],
	"./solid/car.svg": [
		65322,
		65322
	],
	"./solid/caravan.svg": [
		42736,
		42736
	],
	"./solid/caret-down.svg": [
		11635,
		11635
	],
	"./solid/caret-left.svg": [
		17726,
		17726
	],
	"./solid/caret-right.svg": [
		1711,
		1711
	],
	"./solid/caret-up.svg": [
		60884,
		60884
	],
	"./solid/carrot.svg": [
		43413,
		43413
	],
	"./solid/cart-arrow-down.svg": [
		23706,
		23706
	],
	"./solid/cart-flatbed-suitcase.svg": [
		38191,
		38191
	],
	"./solid/cart-flatbed.svg": [
		85432,
		85432
	],
	"./solid/cart-plus.svg": [
		53155,
		53155
	],
	"./solid/cart-shopping.svg": [
		78722,
		78722
	],
	"./solid/cash-register.svg": [
		68421,
		68421
	],
	"./solid/cat.svg": [
		72820,
		72820
	],
	"./solid/cedi-sign.svg": [
		95633,
		95633
	],
	"./solid/cent-sign.svg": [
		80534,
		80534
	],
	"./solid/certificate.svg": [
		80835,
		80835
	],
	"./solid/chair.svg": [
		99422,
		99422
	],
	"./solid/chalkboard-user.svg": [
		53609,
		53609
	],
	"./solid/chalkboard.svg": [
		17101,
		17101
	],
	"./solid/champagne-glasses.svg": [
		78958,
		78958
	],
	"./solid/charging-station.svg": [
		29205,
		29205
	],
	"./solid/chart-area.svg": [
		75546,
		75546
	],
	"./solid/chart-bar.svg": [
		97876,
		97876
	],
	"./solid/chart-column.svg": [
		17129,
		17129
	],
	"./solid/chart-gantt.svg": [
		97031,
		97031
	],
	"./solid/chart-line.svg": [
		10868,
		10868
	],
	"./solid/chart-pie.svg": [
		60068,
		60068
	],
	"./solid/chart-simple.svg": [
		41516,
		41516
	],
	"./solid/check-double.svg": [
		70629,
		70629
	],
	"./solid/check-to-slot.svg": [
		96670,
		96670
	],
	"./solid/check.svg": [
		14095,
		14095
	],
	"./solid/cheese.svg": [
		690,
		690
	],
	"./solid/chess-bishop.svg": [
		62774,
		62774
	],
	"./solid/chess-board.svg": [
		81511,
		81511
	],
	"./solid/chess-king.svg": [
		44847,
		44847
	],
	"./solid/chess-knight.svg": [
		89102,
		89102
	],
	"./solid/chess-pawn.svg": [
		39245,
		39245
	],
	"./solid/chess-queen.svg": [
		49688,
		49688
	],
	"./solid/chess-rook.svg": [
		19371,
		19371
	],
	"./solid/chess.svg": [
		89047,
		89047
	],
	"./solid/chevron-down.svg": [
		41731,
		41731
	],
	"./solid/chevron-left.svg": [
		79107,
		79107
	],
	"./solid/chevron-right.svg": [
		55934,
		55934
	],
	"./solid/chevron-up.svg": [
		26996,
		26996
	],
	"./solid/child-combatant.svg": [
		420,
		420
	],
	"./solid/child-dress.svg": [
		68733,
		68733
	],
	"./solid/child-reaching.svg": [
		36079,
		36079
	],
	"./solid/child.svg": [
		5461,
		5461
	],
	"./solid/children.svg": [
		3963,
		3963
	],
	"./solid/church.svg": [
		11261,
		11261
	],
	"./solid/circle-arrow-down.svg": [
		20791,
		20791
	],
	"./solid/circle-arrow-left.svg": [
		33355,
		33355
	],
	"./solid/circle-arrow-right.svg": [
		19137,
		19137
	],
	"./solid/circle-arrow-up.svg": [
		61790,
		61790
	],
	"./solid/circle-check.svg": [
		27910,
		27910
	],
	"./solid/circle-chevron-down.svg": [
		73704,
		73704
	],
	"./solid/circle-chevron-left.svg": [
		10171,
		10171
	],
	"./solid/circle-chevron-right.svg": [
		41619,
		41619
	],
	"./solid/circle-chevron-up.svg": [
		30939,
		30939
	],
	"./solid/circle-dollar-to-slot.svg": [
		75634,
		75634
	],
	"./solid/circle-dot.svg": [
		65975,
		65975
	],
	"./solid/circle-down.svg": [
		48052,
		48052
	],
	"./solid/circle-exclamation.svg": [
		38029,
		38029
	],
	"./solid/circle-h.svg": [
		1429,
		1429
	],
	"./solid/circle-half-stroke.svg": [
		12371,
		12371
	],
	"./solid/circle-info.svg": [
		88633,
		88633
	],
	"./solid/circle-left.svg": [
		67574,
		67574
	],
	"./solid/circle-minus.svg": [
		85901,
		85901
	],
	"./solid/circle-nodes.svg": [
		34950,
		34950
	],
	"./solid/circle-notch.svg": [
		62212,
		62212
	],
	"./solid/circle-pause.svg": [
		49396,
		49396
	],
	"./solid/circle-play.svg": [
		99385,
		99385
	],
	"./solid/circle-plus.svg": [
		26058,
		26058
	],
	"./solid/circle-question.svg": [
		51882,
		51882
	],
	"./solid/circle-radiation.svg": [
		93519,
		93519
	],
	"./solid/circle-right.svg": [
		54609,
		54609
	],
	"./solid/circle-stop.svg": [
		56557,
		56557
	],
	"./solid/circle-up.svg": [
		81775,
		81775
	],
	"./solid/circle-user.svg": [
		85449,
		85449
	],
	"./solid/circle-xmark.svg": [
		58013,
		58013
	],
	"./solid/circle.svg": [
		93987,
		93987
	],
	"./solid/city.svg": [
		12671,
		12671
	],
	"./solid/clapperboard.svg": [
		91837,
		91837
	],
	"./solid/clipboard-check.svg": [
		43067,
		43067
	],
	"./solid/clipboard-list.svg": [
		92572,
		92572
	],
	"./solid/clipboard-question.svg": [
		22747,
		22747
	],
	"./solid/clipboard-user.svg": [
		57965,
		57965
	],
	"./solid/clipboard.svg": [
		21978,
		21978
	],
	"./solid/clock-rotate-left.svg": [
		83988,
		83988
	],
	"./solid/clock.svg": [
		88131,
		88131
	],
	"./solid/clone.svg": [
		2689,
		2689
	],
	"./solid/closed-captioning.svg": [
		54303,
		54303
	],
	"./solid/cloud-arrow-down.svg": [
		4621,
		4621
	],
	"./solid/cloud-arrow-up.svg": [
		54297,
		54297
	],
	"./solid/cloud-bolt.svg": [
		60630,
		60630
	],
	"./solid/cloud-meatball.svg": [
		86405,
		86405
	],
	"./solid/cloud-moon-rain.svg": [
		75029,
		75029
	],
	"./solid/cloud-moon.svg": [
		62636,
		62636
	],
	"./solid/cloud-rain.svg": [
		8523,
		8523
	],
	"./solid/cloud-showers-heavy.svg": [
		14049,
		14049
	],
	"./solid/cloud-showers-water.svg": [
		51862,
		51862
	],
	"./solid/cloud-sun-rain.svg": [
		17660,
		17660
	],
	"./solid/cloud-sun.svg": [
		14835,
		14835
	],
	"./solid/cloud.svg": [
		8964,
		8964
	],
	"./solid/clover.svg": [
		86003,
		86003
	],
	"./solid/code-branch.svg": [
		40891,
		40891
	],
	"./solid/code-commit.svg": [
		47408,
		47408
	],
	"./solid/code-compare.svg": [
		68084,
		68084
	],
	"./solid/code-fork.svg": [
		22020,
		22020
	],
	"./solid/code-merge.svg": [
		83052,
		83052
	],
	"./solid/code-pull-request.svg": [
		955,
		955
	],
	"./solid/code.svg": [
		79454,
		79454
	],
	"./solid/coins.svg": [
		85713,
		85713
	],
	"./solid/colon-sign.svg": [
		12612,
		12612
	],
	"./solid/comment-dollar.svg": [
		48016,
		48016
	],
	"./solid/comment-dots.svg": [
		27982,
		27982
	],
	"./solid/comment-medical.svg": [
		13591,
		13591
	],
	"./solid/comment-slash.svg": [
		17013,
		17013
	],
	"./solid/comment-sms.svg": [
		85617,
		85617
	],
	"./solid/comment.svg": [
		93561,
		93561
	],
	"./solid/comments-dollar.svg": [
		66868,
		66868
	],
	"./solid/comments.svg": [
		97453,
		97453
	],
	"./solid/compact-disc.svg": [
		98956,
		98956
	],
	"./solid/compass-drafting.svg": [
		31140,
		31140
	],
	"./solid/compass.svg": [
		36232,
		36232
	],
	"./solid/compress.svg": [
		13989,
		13989
	],
	"./solid/computer-mouse.svg": [
		93440,
		93440
	],
	"./solid/computer.svg": [
		45260,
		45260
	],
	"./solid/cookie-bite.svg": [
		74987,
		74987
	],
	"./solid/cookie.svg": [
		79749,
		79749
	],
	"./solid/copy.svg": [
		17510,
		17510
	],
	"./solid/copyright.svg": [
		48072,
		48072
	],
	"./solid/couch.svg": [
		31457,
		31457
	],
	"./solid/cow.svg": [
		2537,
		2537
	],
	"./solid/credit-card.svg": [
		62375,
		62375
	],
	"./solid/crop-simple.svg": [
		11766,
		11766
	],
	"./solid/crop.svg": [
		13673,
		13673
	],
	"./solid/cross.svg": [
		24801,
		24801
	],
	"./solid/crosshairs.svg": [
		80425,
		80425
	],
	"./solid/crow.svg": [
		30693,
		30693
	],
	"./solid/crown.svg": [
		46224,
		46224
	],
	"./solid/crutch.svg": [
		83601,
		83601
	],
	"./solid/cruzeiro-sign.svg": [
		40237,
		40237
	],
	"./solid/cube.svg": [
		35748,
		35748
	],
	"./solid/cubes-stacked.svg": [
		71454,
		71454
	],
	"./solid/cubes.svg": [
		54531,
		54531
	],
	"./solid/d.svg": [
		84240,
		84240
	],
	"./solid/database.svg": [
		49582,
		49582
	],
	"./solid/delete-left.svg": [
		28391,
		28391
	],
	"./solid/democrat.svg": [
		22482,
		22482
	],
	"./solid/desktop.svg": [
		1547,
		1547
	],
	"./solid/dharmachakra.svg": [
		58254,
		58254
	],
	"./solid/diagram-next.svg": [
		88498,
		88498
	],
	"./solid/diagram-predecessor.svg": [
		21228,
		21228
	],
	"./solid/diagram-project.svg": [
		21710,
		21710
	],
	"./solid/diagram-successor.svg": [
		4493,
		4493
	],
	"./solid/diamond-turn-right.svg": [
		26458,
		26458
	],
	"./solid/diamond.svg": [
		41019,
		41019
	],
	"./solid/dice-d20.svg": [
		60404,
		60404
	],
	"./solid/dice-d6.svg": [
		54098,
		54098
	],
	"./solid/dice-five.svg": [
		912,
		912
	],
	"./solid/dice-four.svg": [
		33386,
		33386
	],
	"./solid/dice-one.svg": [
		17389,
		17389
	],
	"./solid/dice-six.svg": [
		94936,
		94936
	],
	"./solid/dice-three.svg": [
		67682,
		67682
	],
	"./solid/dice-two.svg": [
		14377,
		14377
	],
	"./solid/dice.svg": [
		99014,
		99014
	],
	"./solid/disease.svg": [
		17647,
		17647
	],
	"./solid/display.svg": [
		61407,
		61407
	],
	"./solid/divide.svg": [
		43223,
		43223
	],
	"./solid/dna.svg": [
		2769,
		2769
	],
	"./solid/dog.svg": [
		63695,
		63695
	],
	"./solid/dollar-sign.svg": [
		4340,
		4340
	],
	"./solid/dolly.svg": [
		24187,
		24187
	],
	"./solid/dong-sign.svg": [
		70272,
		70272
	],
	"./solid/door-closed.svg": [
		31231,
		31231
	],
	"./solid/door-open.svg": [
		41608,
		41608
	],
	"./solid/dove.svg": [
		48967,
		48967
	],
	"./solid/down-left-and-up-right-to-center.svg": [
		99596,
		99596
	],
	"./solid/down-long.svg": [
		32399,
		32399
	],
	"./solid/download.svg": [
		62895,
		62895
	],
	"./solid/dragon.svg": [
		91695,
		91695
	],
	"./solid/draw-polygon.svg": [
		46307,
		46307
	],
	"./solid/droplet-slash.svg": [
		51158,
		51158
	],
	"./solid/droplet.svg": [
		48321,
		48321
	],
	"./solid/drum-steelpan.svg": [
		12954,
		12954
	],
	"./solid/drum.svg": [
		50991,
		50991
	],
	"./solid/drumstick-bite.svg": [
		60038,
		60038
	],
	"./solid/dumbbell.svg": [
		61335,
		61335
	],
	"./solid/dumpster-fire.svg": [
		55794,
		55794
	],
	"./solid/dumpster.svg": [
		70668,
		70668
	],
	"./solid/dungeon.svg": [
		51945,
		51945
	],
	"./solid/e.svg": [
		57167,
		57167
	],
	"./solid/ear-deaf.svg": [
		5300,
		5300
	],
	"./solid/ear-listen.svg": [
		19053,
		19053
	],
	"./solid/earth-africa.svg": [
		2562,
		2562
	],
	"./solid/earth-americas.svg": [
		34140,
		34140
	],
	"./solid/earth-asia.svg": [
		7145,
		7145
	],
	"./solid/earth-europe.svg": [
		22249,
		22249
	],
	"./solid/earth-oceania.svg": [
		25505,
		25505
	],
	"./solid/egg.svg": [
		68285,
		68285
	],
	"./solid/eject.svg": [
		4070,
		4070
	],
	"./solid/elevator.svg": [
		51228,
		51228
	],
	"./solid/ellipsis-vertical.svg": [
		23443,
		23443
	],
	"./solid/ellipsis.svg": [
		8294,
		8294
	],
	"./solid/envelope-circle-check.svg": [
		72209,
		72209
	],
	"./solid/envelope-open-text.svg": [
		89669,
		89669
	],
	"./solid/envelope-open.svg": [
		65347,
		65347
	],
	"./solid/envelope.svg": [
		35640,
		35640
	],
	"./solid/envelopes-bulk.svg": [
		73195,
		73195
	],
	"./solid/equals.svg": [
		17816,
		30944
	],
	"./solid/eraser.svg": [
		20520,
		20520
	],
	"./solid/ethernet.svg": [
		7894,
		7894
	],
	"./solid/euro-sign.svg": [
		13157,
		13157
	],
	"./solid/exclamation.svg": [
		83800,
		83800
	],
	"./solid/expand.svg": [
		36449,
		12571
	],
	"./solid/explosion.svg": [
		50315,
		50315
	],
	"./solid/eye-dropper.svg": [
		83610,
		83610
	],
	"./solid/eye-low-vision.svg": [
		83082,
		83082
	],
	"./solid/eye-slash.svg": [
		68795,
		68795
	],
	"./solid/eye.svg": [
		85483,
		85483
	],
	"./solid/f.svg": [
		34494,
		34494
	],
	"./solid/face-angry.svg": [
		74262,
		74262
	],
	"./solid/face-dizzy.svg": [
		33258,
		33258
	],
	"./solid/face-flushed.svg": [
		81462,
		81462
	],
	"./solid/face-frown-open.svg": [
		7019,
		7019
	],
	"./solid/face-frown.svg": [
		62477,
		62477
	],
	"./solid/face-grimace.svg": [
		31518,
		31518
	],
	"./solid/face-grin-beam-sweat.svg": [
		49581,
		49581
	],
	"./solid/face-grin-beam.svg": [
		31352,
		31352
	],
	"./solid/face-grin-hearts.svg": [
		54951,
		54951
	],
	"./solid/face-grin-squint-tears.svg": [
		86906,
		86906
	],
	"./solid/face-grin-squint.svg": [
		88714,
		88714
	],
	"./solid/face-grin-stars.svg": [
		38315,
		38315
	],
	"./solid/face-grin-tears.svg": [
		12747,
		12747
	],
	"./solid/face-grin-tongue-squint.svg": [
		34232,
		35533
	],
	"./solid/face-grin-tongue-wink.svg": [
		83446,
		83446
	],
	"./solid/face-grin-tongue.svg": [
		59099,
		59099
	],
	"./solid/face-grin-wide.svg": [
		72462,
		72462
	],
	"./solid/face-grin-wink.svg": [
		39481,
		39481
	],
	"./solid/face-grin.svg": [
		35207,
		35207
	],
	"./solid/face-kiss-beam.svg": [
		17081,
		17081
	],
	"./solid/face-kiss-wink-heart.svg": [
		63765,
		63765
	],
	"./solid/face-kiss.svg": [
		13051,
		13051
	],
	"./solid/face-laugh-beam.svg": [
		14225,
		14225
	],
	"./solid/face-laugh-squint.svg": [
		74171,
		74171
	],
	"./solid/face-laugh-wink.svg": [
		6011,
		6011
	],
	"./solid/face-laugh.svg": [
		41820,
		41820
	],
	"./solid/face-meh-blank.svg": [
		52494,
		52494
	],
	"./solid/face-meh.svg": [
		35552,
		35552
	],
	"./solid/face-rolling-eyes.svg": [
		72399,
		72399
	],
	"./solid/face-sad-cry.svg": [
		56581,
		56581
	],
	"./solid/face-sad-tear.svg": [
		44228,
		44228
	],
	"./solid/face-smile-beam.svg": [
		46932,
		46932
	],
	"./solid/face-smile-wink.svg": [
		57224,
		57224
	],
	"./solid/face-smile.svg": [
		88838,
		88838
	],
	"./solid/face-surprise.svg": [
		22928,
		22928
	],
	"./solid/face-tired.svg": [
		2564,
		2564
	],
	"./solid/fan.svg": [
		93329,
		93329
	],
	"./solid/faucet-drip.svg": [
		23728,
		23728
	],
	"./solid/faucet.svg": [
		58853,
		58853
	],
	"./solid/fax.svg": [
		94734,
		94734
	],
	"./solid/feather-pointed.svg": [
		21799,
		21799
	],
	"./solid/feather.svg": [
		70205,
		70205
	],
	"./solid/ferry.svg": [
		98634,
		98634
	],
	"./solid/file-arrow-down.svg": [
		88520,
		88520
	],
	"./solid/file-arrow-up.svg": [
		59073,
		32590
	],
	"./solid/file-audio.svg": [
		3097,
		3097
	],
	"./solid/file-circle-check.svg": [
		86016,
		86016
	],
	"./solid/file-circle-exclamation.svg": [
		49514,
		49514
	],
	"./solid/file-circle-minus.svg": [
		21891,
		15068
	],
	"./solid/file-circle-plus.svg": [
		72468,
		72468
	],
	"./solid/file-circle-question.svg": [
		27461,
		27461
	],
	"./solid/file-circle-xmark.svg": [
		26120,
		26120
	],
	"./solid/file-code.svg": [
		3045,
		3045
	],
	"./solid/file-contract.svg": [
		12503,
		12503
	],
	"./solid/file-csv.svg": [
		76841,
		76841
	],
	"./solid/file-excel.svg": [
		7221,
		7221
	],
	"./solid/file-export.svg": [
		36447,
		36447
	],
	"./solid/file-image.svg": [
		6263,
		6263
	],
	"./solid/file-import.svg": [
		27202,
		27202
	],
	"./solid/file-invoice-dollar.svg": [
		60121,
		60121
	],
	"./solid/file-invoice.svg": [
		8542,
		8542
	],
	"./solid/file-lines.svg": [
		80439,
		80439
	],
	"./solid/file-medical.svg": [
		25637,
		25637
	],
	"./solid/file-pdf.svg": [
		84537,
		84537
	],
	"./solid/file-pen.svg": [
		44235,
		44235
	],
	"./solid/file-powerpoint.svg": [
		15196,
		15196
	],
	"./solid/file-prescription.svg": [
		60531,
		60531
	],
	"./solid/file-shield.svg": [
		74114,
		74114
	],
	"./solid/file-signature.svg": [
		23315,
		23315
	],
	"./solid/file-video.svg": [
		64682,
		64682
	],
	"./solid/file-waveform.svg": [
		65600,
		65600
	],
	"./solid/file-word.svg": [
		59539,
		59539
	],
	"./solid/file-zipper.svg": [
		30827,
		30827
	],
	"./solid/file.svg": [
		5308,
		5308
	],
	"./solid/fill-drip.svg": [
		18066,
		18066
	],
	"./solid/fill.svg": [
		94744,
		94744
	],
	"./solid/film.svg": [
		21828,
		21828
	],
	"./solid/filter-circle-dollar.svg": [
		17555,
		17555
	],
	"./solid/filter-circle-xmark.svg": [
		34518,
		34518
	],
	"./solid/filter.svg": [
		65737,
		65737
	],
	"./solid/fingerprint.svg": [
		61166,
		61166
	],
	"./solid/fire-burner.svg": [
		49467,
		49467
	],
	"./solid/fire-extinguisher.svg": [
		43870,
		43870
	],
	"./solid/fire-flame-curved.svg": [
		63402,
		63402
	],
	"./solid/fire-flame-simple.svg": [
		4169,
		4169
	],
	"./solid/fire.svg": [
		7905,
		7905
	],
	"./solid/fish-fins.svg": [
		40306,
		40306
	],
	"./solid/fish.svg": [
		91348,
		9695
	],
	"./solid/flag-checkered.svg": [
		96827,
		96827
	],
	"./solid/flag-usa.svg": [
		60922,
		60922
	],
	"./solid/flag.svg": [
		60986,
		60986
	],
	"./solid/flask-vial.svg": [
		74491,
		74491
	],
	"./solid/flask.svg": [
		5218,
		26709
	],
	"./solid/floppy-disk.svg": [
		8220,
		8220
	],
	"./solid/florin-sign.svg": [
		83574,
		83574
	],
	"./solid/folder-closed.svg": [
		64833,
		64833
	],
	"./solid/folder-minus.svg": [
		78568,
		78568
	],
	"./solid/folder-open.svg": [
		19479,
		19479
	],
	"./solid/folder-plus.svg": [
		73775,
		23768
	],
	"./solid/folder-tree.svg": [
		5139,
		5139
	],
	"./solid/folder.svg": [
		33581,
		33581
	],
	"./solid/font-awesome.svg": [
		51711,
		51711
	],
	"./solid/font.svg": [
		85764,
		85764
	],
	"./solid/football.svg": [
		89183,
		89183
	],
	"./solid/forward-fast.svg": [
		79363,
		79363
	],
	"./solid/forward-step.svg": [
		78539,
		78539
	],
	"./solid/forward.svg": [
		70097,
		70097
	],
	"./solid/franc-sign.svg": [
		72459,
		72459
	],
	"./solid/frog.svg": [
		47701,
		47701
	],
	"./solid/futbol.svg": [
		29763,
		29763
	],
	"./solid/g.svg": [
		94990,
		94990
	],
	"./solid/gamepad.svg": [
		3838,
		3838
	],
	"./solid/gas-pump.svg": [
		7477,
		7477
	],
	"./solid/gauge-high.svg": [
		78337,
		78337
	],
	"./solid/gauge-simple-high.svg": [
		67410,
		67410
	],
	"./solid/gauge-simple.svg": [
		42809,
		42809
	],
	"./solid/gauge.svg": [
		56681,
		56681
	],
	"./solid/gavel.svg": [
		83730,
		83730
	],
	"./solid/gear.svg": [
		74719,
		74719
	],
	"./solid/gears.svg": [
		43537,
		43537
	],
	"./solid/gem.svg": [
		34242,
		34242
	],
	"./solid/genderless.svg": [
		96384,
		96384
	],
	"./solid/ghost.svg": [
		68771,
		68771
	],
	"./solid/gift.svg": [
		95466,
		95466
	],
	"./solid/gifts.svg": [
		65992,
		65992
	],
	"./solid/glass-water-droplet.svg": [
		73883,
		73883
	],
	"./solid/glass-water.svg": [
		41232,
		65101
	],
	"./solid/glasses.svg": [
		68516,
		68516
	],
	"./solid/globe.svg": [
		94219,
		94219
	],
	"./solid/golf-ball-tee.svg": [
		92707,
		92707
	],
	"./solid/gopuram.svg": [
		63011,
		63011
	],
	"./solid/graduation-cap.svg": [
		37162,
		37162
	],
	"./solid/greater-than-equal.svg": [
		91390,
		91390
	],
	"./solid/greater-than.svg": [
		32587,
		32587
	],
	"./solid/grip-lines-vertical.svg": [
		37183,
		37183
	],
	"./solid/grip-lines.svg": [
		46162,
		46162
	],
	"./solid/grip-vertical.svg": [
		54764,
		54764
	],
	"./solid/grip.svg": [
		13767,
		13767
	],
	"./solid/group-arrows-rotate.svg": [
		72212,
		72212
	],
	"./solid/guarani-sign.svg": [
		83587,
		83587
	],
	"./solid/guitar.svg": [
		10120,
		10120
	],
	"./solid/gun.svg": [
		72106,
		72106
	],
	"./solid/h.svg": [
		67628,
		67628
	],
	"./solid/hammer.svg": [
		65154,
		65154
	],
	"./solid/hamsa.svg": [
		49117,
		49117
	],
	"./solid/hand-back-fist.svg": [
		61796,
		61796
	],
	"./solid/hand-dots.svg": [
		38143,
		38143
	],
	"./solid/hand-fist.svg": [
		14061,
		40174
	],
	"./solid/hand-holding-dollar.svg": [
		90745,
		90745
	],
	"./solid/hand-holding-droplet.svg": [
		31092,
		31092
	],
	"./solid/hand-holding-hand.svg": [
		58251,
		58251
	],
	"./solid/hand-holding-heart.svg": [
		4850,
		4850
	],
	"./solid/hand-holding-medical.svg": [
		14289,
		14289
	],
	"./solid/hand-holding.svg": [
		54972,
		54972
	],
	"./solid/hand-lizard.svg": [
		983,
		8446
	],
	"./solid/hand-middle-finger.svg": [
		95698,
		95698
	],
	"./solid/hand-peace.svg": [
		61158,
		61158
	],
	"./solid/hand-point-down.svg": [
		72301,
		72301
	],
	"./solid/hand-point-left.svg": [
		661,
		661
	],
	"./solid/hand-point-right.svg": [
		8152,
		8152
	],
	"./solid/hand-point-up.svg": [
		85077,
		85077
	],
	"./solid/hand-pointer.svg": [
		20337,
		20337
	],
	"./solid/hand-scissors.svg": [
		38105,
		38105
	],
	"./solid/hand-sparkles.svg": [
		47977,
		47977
	],
	"./solid/hand-spock.svg": [
		53631,
		53631
	],
	"./solid/hand.svg": [
		92620,
		92620
	],
	"./solid/handcuffs.svg": [
		47344,
		47344
	],
	"./solid/hands-asl-interpreting.svg": [
		16587,
		16587
	],
	"./solid/hands-bound.svg": [
		64277,
		64277
	],
	"./solid/hands-bubbles.svg": [
		56185,
		56185
	],
	"./solid/hands-clapping.svg": [
		75867,
		75867
	],
	"./solid/hands-holding-child.svg": [
		8751,
		8751
	],
	"./solid/hands-holding-circle.svg": [
		55767,
		55767
	],
	"./solid/hands-holding.svg": [
		17063,
		17063
	],
	"./solid/hands-praying.svg": [
		16402,
		16402
	],
	"./solid/hands.svg": [
		21489,
		21489
	],
	"./solid/handshake-angle.svg": [
		37654,
		37654
	],
	"./solid/handshake-simple-slash.svg": [
		62753,
		62753
	],
	"./solid/handshake-simple.svg": [
		84423,
		84423
	],
	"./solid/handshake-slash.svg": [
		37618,
		37618
	],
	"./solid/handshake.svg": [
		8477,
		8477
	],
	"./solid/hanukiah.svg": [
		67319,
		67319
	],
	"./solid/hard-drive.svg": [
		12921,
		12921
	],
	"./solid/hashtag.svg": [
		21173,
		21173
	],
	"./solid/hat-cowboy-side.svg": [
		69843,
		69843
	],
	"./solid/hat-cowboy.svg": [
		77610,
		77610
	],
	"./solid/hat-wizard.svg": [
		80601,
		80601
	],
	"./solid/head-side-cough-slash.svg": [
		53341,
		53341
	],
	"./solid/head-side-cough.svg": [
		24224,
		24224
	],
	"./solid/head-side-mask.svg": [
		79432,
		79432
	],
	"./solid/head-side-virus.svg": [
		67754,
		67754
	],
	"./solid/heading.svg": [
		79788,
		79788
	],
	"./solid/headphones-simple.svg": [
		48645,
		48645
	],
	"./solid/headphones.svg": [
		2407,
		2407
	],
	"./solid/headset.svg": [
		3307,
		3307
	],
	"./solid/heart-circle-bolt.svg": [
		61349,
		61349
	],
	"./solid/heart-circle-check.svg": [
		49661,
		49661
	],
	"./solid/heart-circle-exclamation.svg": [
		6672,
		6672
	],
	"./solid/heart-circle-minus.svg": [
		6172,
		6172
	],
	"./solid/heart-circle-plus.svg": [
		6721,
		6721
	],
	"./solid/heart-circle-xmark.svg": [
		33196,
		33196
	],
	"./solid/heart-crack.svg": [
		37445,
		37445
	],
	"./solid/heart-pulse.svg": [
		53378,
		53378
	],
	"./solid/heart.svg": [
		75104,
		75104
	],
	"./solid/helicopter-symbol.svg": [
		74909,
		74909
	],
	"./solid/helicopter.svg": [
		63465,
		63465
	],
	"./solid/helmet-safety.svg": [
		71548,
		71548
	],
	"./solid/helmet-un.svg": [
		62434,
		62434
	],
	"./solid/highlighter.svg": [
		44542,
		44542
	],
	"./solid/hill-avalanche.svg": [
		32376,
		32376
	],
	"./solid/hill-rockslide.svg": [
		86413,
		86413
	],
	"./solid/hippo.svg": [
		79052,
		79052
	],
	"./solid/hockey-puck.svg": [
		98356,
		98356
	],
	"./solid/holly-berry.svg": [
		94452,
		94452
	],
	"./solid/horse-head.svg": [
		37470,
		37470
	],
	"./solid/horse.svg": [
		99983,
		99983
	],
	"./solid/hospital-user.svg": [
		88021,
		88021
	],
	"./solid/hospital.svg": [
		31918,
		31918
	],
	"./solid/hot-tub-person.svg": [
		30484,
		30484
	],
	"./solid/hotdog.svg": [
		70418,
		70418
	],
	"./solid/hotel.svg": [
		31724,
		31724
	],
	"./solid/hourglass-end.svg": [
		16139,
		16139
	],
	"./solid/hourglass-half.svg": [
		49449,
		49449
	],
	"./solid/hourglass-start.svg": [
		22703,
		22703
	],
	"./solid/hourglass.svg": [
		31769,
		31769
	],
	"./solid/house-chimney-crack.svg": [
		22489,
		45585
	],
	"./solid/house-chimney-medical.svg": [
		85507,
		85507
	],
	"./solid/house-chimney-user.svg": [
		24823,
		24823
	],
	"./solid/house-chimney-window.svg": [
		83225,
		83225
	],
	"./solid/house-chimney.svg": [
		14179,
		14179
	],
	"./solid/house-circle-check.svg": [
		15418,
		15418
	],
	"./solid/house-circle-exclamation.svg": [
		81063,
		81063
	],
	"./solid/house-circle-xmark.svg": [
		21021,
		21021
	],
	"./solid/house-crack.svg": [
		29254,
		29254
	],
	"./solid/house-fire.svg": [
		2457,
		2457
	],
	"./solid/house-flag.svg": [
		68118,
		68118
	],
	"./solid/house-flood-water-circle-arrow-right.svg": [
		46272,
		46272
	],
	"./solid/house-flood-water.svg": [
		13627,
		13627
	],
	"./solid/house-laptop.svg": [
		1514,
		1514
	],
	"./solid/house-lock.svg": [
		68022,
		68022
	],
	"./solid/house-medical-circle-check.svg": [
		43152,
		43152
	],
	"./solid/house-medical-circle-exclamation.svg": [
		75992,
		75992
	],
	"./solid/house-medical-circle-xmark.svg": [
		3349,
		3349
	],
	"./solid/house-medical-flag.svg": [
		66004,
		66004
	],
	"./solid/house-medical.svg": [
		43178,
		43178
	],
	"./solid/house-signal.svg": [
		54993,
		54993
	],
	"./solid/house-tsunami.svg": [
		22785,
		22785
	],
	"./solid/house-user.svg": [
		90152,
		90152
	],
	"./solid/house.svg": [
		63393,
		63393
	],
	"./solid/hryvnia-sign.svg": [
		9251,
		9251
	],
	"./solid/hurricane.svg": [
		59969,
		59969
	],
	"./solid/i-cursor.svg": [
		53053,
		53053
	],
	"./solid/i.svg": [
		18324,
		18324
	],
	"./solid/ice-cream.svg": [
		34293,
		34293
	],
	"./solid/icicles.svg": [
		72674,
		72674
	],
	"./solid/icons.svg": [
		16895,
		16895
	],
	"./solid/id-badge.svg": [
		16621,
		16621
	],
	"./solid/id-card-clip.svg": [
		40541,
		40541
	],
	"./solid/id-card.svg": [
		35111,
		35111
	],
	"./solid/igloo.svg": [
		78184,
		78184
	],
	"./solid/image-portrait.svg": [
		21918,
		21918
	],
	"./solid/image.svg": [
		87629,
		87629
	],
	"./solid/images.svg": [
		69825,
		69825
	],
	"./solid/inbox.svg": [
		75076,
		75076
	],
	"./solid/indent.svg": [
		15131,
		15131
	],
	"./solid/indian-rupee-sign.svg": [
		24807,
		24807
	],
	"./solid/industry.svg": [
		2146,
		2146
	],
	"./solid/infinity.svg": [
		90567,
		90567
	],
	"./solid/info.svg": [
		33779,
		33779
	],
	"./solid/italic.svg": [
		26076,
		26076
	],
	"./solid/j.svg": [
		78920,
		78920
	],
	"./solid/jar-wheat.svg": [
		73891,
		73891
	],
	"./solid/jar.svg": [
		92219,
		92219
	],
	"./solid/jedi.svg": [
		8865,
		8865
	],
	"./solid/jet-fighter-up.svg": [
		25288,
		25288
	],
	"./solid/jet-fighter.svg": [
		15307,
		15307
	],
	"./solid/joint.svg": [
		56051,
		56051
	],
	"./solid/jug-detergent.svg": [
		79784,
		79784
	],
	"./solid/k.svg": [
		78227,
		78227
	],
	"./solid/kaaba.svg": [
		91566,
		91566
	],
	"./solid/key.svg": [
		14689,
		14689
	],
	"./solid/keyboard.svg": [
		69252,
		69252
	],
	"./solid/khanda.svg": [
		76391,
		76391
	],
	"./solid/kip-sign.svg": [
		80052,
		80052
	],
	"./solid/kit-medical.svg": [
		33812,
		33812
	],
	"./solid/kitchen-set.svg": [
		69277,
		69277
	],
	"./solid/kiwi-bird.svg": [
		36680,
		98382
	],
	"./solid/l.svg": [
		52500,
		52500
	],
	"./solid/land-mine-on.svg": [
		20382,
		20382
	],
	"./solid/landmark-dome.svg": [
		98589,
		98589
	],
	"./solid/landmark-flag.svg": [
		31914,
		31914
	],
	"./solid/landmark.svg": [
		55762,
		55762
	],
	"./solid/language.svg": [
		60937,
		60937
	],
	"./solid/laptop-code.svg": [
		94436,
		94436
	],
	"./solid/laptop-file.svg": [
		12863,
		12863
	],
	"./solid/laptop-medical.svg": [
		65820,
		52511
	],
	"./solid/laptop.svg": [
		80126,
		80126
	],
	"./solid/lari-sign.svg": [
		24351,
		24351
	],
	"./solid/layer-group.svg": [
		16102,
		25889
	],
	"./solid/leaf.svg": [
		74686,
		74686
	],
	"./solid/left-long.svg": [
		54046,
		54046
	],
	"./solid/left-right.svg": [
		23243,
		23243
	],
	"./solid/lemon.svg": [
		22465,
		22465
	],
	"./solid/less-than-equal.svg": [
		8391,
		8391
	],
	"./solid/less-than.svg": [
		39175,
		39175
	],
	"./solid/life-ring.svg": [
		1662,
		1662
	],
	"./solid/lightbulb.svg": [
		17564,
		17564
	],
	"./solid/lines-leaning.svg": [
		28685,
		28685
	],
	"./solid/link-slash.svg": [
		12109,
		12109
	],
	"./solid/link.svg": [
		5610,
		5610
	],
	"./solid/lira-sign.svg": [
		86442,
		86442
	],
	"./solid/list-check.svg": [
		5701,
		5701
	],
	"./solid/list-ol.svg": [
		45057,
		45057
	],
	"./solid/list-ul.svg": [
		30391,
		30391
	],
	"./solid/list.svg": [
		3526,
		3526
	],
	"./solid/litecoin-sign.svg": [
		11894,
		11894
	],
	"./solid/location-arrow.svg": [
		64996,
		64996
	],
	"./solid/location-crosshairs.svg": [
		96472,
		96472
	],
	"./solid/location-dot.svg": [
		5036,
		5036
	],
	"./solid/location-pin-lock.svg": [
		71508,
		71508
	],
	"./solid/location-pin.svg": [
		66822,
		66822
	],
	"./solid/lock-open.svg": [
		77846,
		77846
	],
	"./solid/lock.svg": [
		93652,
		93652
	],
	"./solid/locust.svg": [
		30198,
		30198
	],
	"./solid/lungs-virus.svg": [
		54714,
		54714
	],
	"./solid/lungs.svg": [
		80298,
		80298
	],
	"./solid/m.svg": [
		84833,
		84833
	],
	"./solid/magnet.svg": [
		30660,
		30660
	],
	"./solid/magnifying-glass-arrow-right.svg": [
		20312,
		20312
	],
	"./solid/magnifying-glass-chart.svg": [
		42076,
		42076
	],
	"./solid/magnifying-glass-dollar.svg": [
		65636,
		65636
	],
	"./solid/magnifying-glass-location.svg": [
		17365,
		17365
	],
	"./solid/magnifying-glass-minus.svg": [
		35751,
		35751
	],
	"./solid/magnifying-glass-plus.svg": [
		51160,
		51160
	],
	"./solid/magnifying-glass.svg": [
		73009,
		73009
	],
	"./solid/manat-sign.svg": [
		21563,
		21563
	],
	"./solid/map-location-dot.svg": [
		5438,
		5438
	],
	"./solid/map-location.svg": [
		11372,
		11372
	],
	"./solid/map-pin.svg": [
		47279,
		47279
	],
	"./solid/map.svg": [
		63159,
		63159
	],
	"./solid/marker.svg": [
		17210,
		17210
	],
	"./solid/mars-and-venus-burst.svg": [
		14710,
		14710
	],
	"./solid/mars-and-venus.svg": [
		23509,
		23509
	],
	"./solid/mars-double.svg": [
		58160,
		58160
	],
	"./solid/mars-stroke-right.svg": [
		81655,
		81655
	],
	"./solid/mars-stroke-up.svg": [
		11786,
		11786
	],
	"./solid/mars-stroke.svg": [
		76380,
		76380
	],
	"./solid/mars.svg": [
		49840,
		49840
	],
	"./solid/martini-glass-citrus.svg": [
		43435,
		43435
	],
	"./solid/martini-glass-empty.svg": [
		90078,
		90078
	],
	"./solid/martini-glass.svg": [
		2486,
		2486
	],
	"./solid/mask-face.svg": [
		38611,
		38611
	],
	"./solid/mask-ventilator.svg": [
		9878,
		9878
	],
	"./solid/mask.svg": [
		48041,
		48041
	],
	"./solid/masks-theater.svg": [
		36950,
		36950
	],
	"./solid/mattress-pillow.svg": [
		40497,
		40497
	],
	"./solid/maximize.svg": [
		67519,
		67519
	],
	"./solid/medal.svg": [
		70729,
		70729
	],
	"./solid/memory.svg": [
		61141,
		61141
	],
	"./solid/menorah.svg": [
		96356,
		96356
	],
	"./solid/mercury.svg": [
		48157,
		48157
	],
	"./solid/message.svg": [
		68379,
		68379
	],
	"./solid/meteor.svg": [
		79086,
		79086
	],
	"./solid/microchip.svg": [
		52635,
		52635
	],
	"./solid/microphone-lines-slash.svg": [
		94318,
		94318
	],
	"./solid/microphone-lines.svg": [
		35741,
		35741
	],
	"./solid/microphone-slash.svg": [
		22726,
		22726
	],
	"./solid/microphone.svg": [
		87199,
		87199
	],
	"./solid/microscope.svg": [
		5343,
		5343
	],
	"./solid/mill-sign.svg": [
		98237,
		98237
	],
	"./solid/minimize.svg": [
		47751,
		47751
	],
	"./solid/minus.svg": [
		81419,
		81419
	],
	"./solid/mitten.svg": [
		57551,
		57551
	],
	"./solid/mobile-button.svg": [
		40584,
		40584
	],
	"./solid/mobile-retro.svg": [
		57024,
		57024
	],
	"./solid/mobile-screen-button.svg": [
		70693,
		70693
	],
	"./solid/mobile-screen.svg": [
		49479,
		49479
	],
	"./solid/mobile.svg": [
		63714,
		63714
	],
	"./solid/money-bill-1-wave.svg": [
		59869,
		59869
	],
	"./solid/money-bill-1.svg": [
		20066,
		20066
	],
	"./solid/money-bill-transfer.svg": [
		29934,
		29934
	],
	"./solid/money-bill-trend-up.svg": [
		33633,
		33633
	],
	"./solid/money-bill-wave.svg": [
		74539,
		74539
	],
	"./solid/money-bill-wheat.svg": [
		29987,
		29987
	],
	"./solid/money-bill.svg": [
		58691,
		58691
	],
	"./solid/money-bills.svg": [
		48113,
		48113
	],
	"./solid/money-check-dollar.svg": [
		46292,
		46292
	],
	"./solid/money-check.svg": [
		56780,
		56780
	],
	"./solid/monument.svg": [
		96421,
		96421
	],
	"./solid/moon.svg": [
		98354,
		98354
	],
	"./solid/mortar-pestle.svg": [
		88665,
		88665
	],
	"./solid/mosque.svg": [
		22250,
		22250
	],
	"./solid/mosquito-net.svg": [
		50086,
		50086
	],
	"./solid/mosquito.svg": [
		61751,
		61751
	],
	"./solid/motorcycle.svg": [
		22663,
		22663
	],
	"./solid/mound.svg": [
		91831,
		91831
	],
	"./solid/mountain-city.svg": [
		37826,
		37826
	],
	"./solid/mountain-sun.svg": [
		80532,
		80532
	],
	"./solid/mountain.svg": [
		41015,
		41015
	],
	"./solid/mug-hot.svg": [
		46880,
		46880
	],
	"./solid/mug-saucer.svg": [
		54449,
		54449
	],
	"./solid/music.svg": [
		28070,
		28070
	],
	"./solid/n.svg": [
		96795,
		96795
	],
	"./solid/naira-sign.svg": [
		28117,
		28117
	],
	"./solid/network-wired.svg": [
		69130,
		69130
	],
	"./solid/neuter.svg": [
		11980,
		11980
	],
	"./solid/newspaper.svg": [
		84553,
		84553
	],
	"./solid/not-equal.svg": [
		44728,
		44728
	],
	"./solid/notdef.svg": [
		90512,
		90512
	],
	"./solid/note-sticky.svg": [
		66469,
		66469
	],
	"./solid/notes-medical.svg": [
		83749,
		83749
	],
	"./solid/o.svg": [
		15116,
		15116
	],
	"./solid/object-group.svg": [
		44978,
		44978
	],
	"./solid/object-ungroup.svg": [
		3666,
		3666
	],
	"./solid/oil-can.svg": [
		33152,
		33152
	],
	"./solid/oil-well.svg": [
		14426,
		14426
	],
	"./solid/om.svg": [
		4600,
		4600
	],
	"./solid/otter.svg": [
		54135,
		54135
	],
	"./solid/outdent.svg": [
		5697,
		5697
	],
	"./solid/p.svg": [
		29519,
		29519
	],
	"./solid/pager.svg": [
		44328,
		44328
	],
	"./solid/paint-roller.svg": [
		87790,
		87790
	],
	"./solid/paintbrush.svg": [
		20823,
		20823
	],
	"./solid/palette.svg": [
		48397,
		48397
	],
	"./solid/pallet.svg": [
		88287,
		88287
	],
	"./solid/panorama.svg": [
		17473,
		17473
	],
	"./solid/paper-plane.svg": [
		58396,
		58396
	],
	"./solid/paperclip.svg": [
		50068,
		50068
	],
	"./solid/parachute-box.svg": [
		79230,
		79230
	],
	"./solid/paragraph.svg": [
		1323,
		1323
	],
	"./solid/passport.svg": [
		39572,
		39572
	],
	"./solid/paste.svg": [
		24560,
		29265
	],
	"./solid/pause.svg": [
		29818,
		29818
	],
	"./solid/paw.svg": [
		49728,
		49728
	],
	"./solid/peace.svg": [
		61277,
		61277
	],
	"./solid/pen-clip.svg": [
		35317,
		35317
	],
	"./solid/pen-fancy.svg": [
		96492,
		96492
	],
	"./solid/pen-nib.svg": [
		66018,
		66018
	],
	"./solid/pen-ruler.svg": [
		85516,
		85516
	],
	"./solid/pen-to-square.svg": [
		23389,
		23389
	],
	"./solid/pen.svg": [
		18925,
		18925
	],
	"./solid/pencil.svg": [
		17972,
		17972
	],
	"./solid/people-arrows.svg": [
		35049,
		35049
	],
	"./solid/people-carry-box.svg": [
		10639,
		66341
	],
	"./solid/people-group.svg": [
		97798,
		85277
	],
	"./solid/people-line.svg": [
		48178,
		48178
	],
	"./solid/people-pulling.svg": [
		11541,
		11541
	],
	"./solid/people-robbery.svg": [
		57148,
		57148
	],
	"./solid/people-roof.svg": [
		14597,
		14597
	],
	"./solid/pepper-hot.svg": [
		28039,
		28039
	],
	"./solid/percent.svg": [
		37866,
		37866
	],
	"./solid/person-arrow-down-to-line.svg": [
		86840,
		86840
	],
	"./solid/person-arrow-up-from-line.svg": [
		6276,
		6276
	],
	"./solid/person-biking.svg": [
		61619,
		61619
	],
	"./solid/person-booth.svg": [
		47282,
		47282
	],
	"./solid/person-breastfeeding.svg": [
		64754,
		64754
	],
	"./solid/person-burst.svg": [
		96807,
		96807
	],
	"./solid/person-cane.svg": [
		91539,
		91539
	],
	"./solid/person-chalkboard.svg": [
		28251,
		28251
	],
	"./solid/person-circle-check.svg": [
		52186,
		52186
	],
	"./solid/person-circle-exclamation.svg": [
		53666,
		53666
	],
	"./solid/person-circle-minus.svg": [
		75816,
		75816
	],
	"./solid/person-circle-plus.svg": [
		62575,
		62575
	],
	"./solid/person-circle-question.svg": [
		74225,
		74225
	],
	"./solid/person-circle-xmark.svg": [
		6072,
		6072
	],
	"./solid/person-digging.svg": [
		9300,
		9300
	],
	"./solid/person-dots-from-line.svg": [
		47994,
		47994
	],
	"./solid/person-dress-burst.svg": [
		58135,
		58135
	],
	"./solid/person-dress.svg": [
		76709,
		76709
	],
	"./solid/person-drowning.svg": [
		88774,
		88774
	],
	"./solid/person-falling-burst.svg": [
		31921,
		31921
	],
	"./solid/person-falling.svg": [
		89458,
		89458
	],
	"./solid/person-half-dress.svg": [
		58183,
		58183
	],
	"./solid/person-harassing.svg": [
		28234,
		28234
	],
	"./solid/person-hiking.svg": [
		34590,
		34590
	],
	"./solid/person-military-pointing.svg": [
		68089,
		68089
	],
	"./solid/person-military-rifle.svg": [
		54058,
		54058
	],
	"./solid/person-military-to-person.svg": [
		55128,
		55128
	],
	"./solid/person-praying.svg": [
		53863,
		53863
	],
	"./solid/person-pregnant.svg": [
		79890,
		79890
	],
	"./solid/person-rays.svg": [
		60774,
		60774
	],
	"./solid/person-rifle.svg": [
		15261,
		15261
	],
	"./solid/person-running.svg": [
		33565,
		33565
	],
	"./solid/person-shelter.svg": [
		95138,
		95138
	],
	"./solid/person-skating.svg": [
		20798,
		20798
	],
	"./solid/person-skiing-nordic.svg": [
		24005,
		24005
	],
	"./solid/person-skiing.svg": [
		42929,
		42929
	],
	"./solid/person-snowboarding.svg": [
		92755,
		92755
	],
	"./solid/person-swimming.svg": [
		65998,
		65998
	],
	"./solid/person-through-window.svg": [
		5881,
		5881
	],
	"./solid/person-walking-arrow-loop-left.svg": [
		97827,
		97827
	],
	"./solid/person-walking-arrow-right.svg": [
		23700,
		23700
	],
	"./solid/person-walking-dashed-line-arrow-right.svg": [
		1154,
		1154
	],
	"./solid/person-walking-luggage.svg": [
		16191,
		16191
	],
	"./solid/person-walking-with-cane.svg": [
		25855,
		25855
	],
	"./solid/person-walking.svg": [
		94322,
		94322
	],
	"./solid/person.svg": [
		80797,
		1300
	],
	"./solid/peseta-sign.svg": [
		73245,
		73245
	],
	"./solid/peso-sign.svg": [
		81590,
		50822
	],
	"./solid/phone-flip.svg": [
		2090,
		2090
	],
	"./solid/phone-slash.svg": [
		39284,
		39284
	],
	"./solid/phone-volume.svg": [
		35152,
		35152
	],
	"./solid/phone.svg": [
		58203,
		58203
	],
	"./solid/photo-film.svg": [
		7662,
		7662
	],
	"./solid/piggy-bank.svg": [
		82914,
		82914
	],
	"./solid/pills.svg": [
		51109,
		51109
	],
	"./solid/pizza-slice.svg": [
		45362,
		45362
	],
	"./solid/place-of-worship.svg": [
		65099,
		65099
	],
	"./solid/plane-arrival.svg": [
		92728,
		92728
	],
	"./solid/plane-circle-check.svg": [
		5924,
		5924
	],
	"./solid/plane-circle-exclamation.svg": [
		84565,
		84565
	],
	"./solid/plane-circle-xmark.svg": [
		22041,
		22041
	],
	"./solid/plane-departure.svg": [
		69040,
		69040
	],
	"./solid/plane-lock.svg": [
		12950,
		12950
	],
	"./solid/plane-slash.svg": [
		44688,
		44688
	],
	"./solid/plane-up.svg": [
		79298,
		79298
	],
	"./solid/plane.svg": [
		51305,
		51305
	],
	"./solid/plant-wilt.svg": [
		62603,
		62603
	],
	"./solid/plate-wheat.svg": [
		93170,
		93170
	],
	"./solid/play.svg": [
		74511,
		74511
	],
	"./solid/plug-circle-bolt.svg": [
		44077,
		44077
	],
	"./solid/plug-circle-check.svg": [
		73725,
		73725
	],
	"./solid/plug-circle-exclamation.svg": [
		92690,
		92690
	],
	"./solid/plug-circle-minus.svg": [
		82390,
		82390
	],
	"./solid/plug-circle-plus.svg": [
		2213,
		2213
	],
	"./solid/plug-circle-xmark.svg": [
		27773,
		27773
	],
	"./solid/plug.svg": [
		83228,
		83228
	],
	"./solid/plus-minus.svg": [
		55117,
		55117
	],
	"./solid/plus.svg": [
		15080,
		15080
	],
	"./solid/podcast.svg": [
		50999,
		50999
	],
	"./solid/poo-storm.svg": [
		82320,
		82320
	],
	"./solid/poo.svg": [
		49782,
		49782
	],
	"./solid/poop.svg": [
		14184,
		14184
	],
	"./solid/power-off.svg": [
		11265,
		11265
	],
	"./solid/prescription-bottle-medical.svg": [
		76073,
		76073
	],
	"./solid/prescription-bottle.svg": [
		54481,
		54481
	],
	"./solid/prescription.svg": [
		75397,
		75397
	],
	"./solid/print.svg": [
		95667,
		95667
	],
	"./solid/pump-medical.svg": [
		62161,
		62161
	],
	"./solid/pump-soap.svg": [
		66514,
		66514
	],
	"./solid/puzzle-piece.svg": [
		44540,
		44540
	],
	"./solid/q.svg": [
		84669,
		84669
	],
	"./solid/qrcode.svg": [
		57106,
		57106
	],
	"./solid/question.svg": [
		36282,
		36282
	],
	"./solid/quote-left.svg": [
		70242,
		70242
	],
	"./solid/quote-right.svg": [
		95669,
		95669
	],
	"./solid/r.svg": [
		21262,
		21262
	],
	"./solid/radiation.svg": [
		40844,
		40844
	],
	"./solid/radio.svg": [
		37025,
		37025
	],
	"./solid/rainbow.svg": [
		17886,
		17886
	],
	"./solid/ranking-star.svg": [
		61984,
		61984
	],
	"./solid/receipt.svg": [
		7980,
		7980
	],
	"./solid/record-vinyl.svg": [
		97492,
		97492
	],
	"./solid/rectangle-ad.svg": [
		27927,
		27927
	],
	"./solid/rectangle-list.svg": [
		49003,
		49003
	],
	"./solid/rectangle-xmark.svg": [
		90751,
		90751
	],
	"./solid/recycle.svg": [
		46945,
		46945
	],
	"./solid/registered.svg": [
		51559,
		51559
	],
	"./solid/repeat.svg": [
		90044,
		90044
	],
	"./solid/reply-all.svg": [
		75360,
		75360
	],
	"./solid/reply.svg": [
		28433,
		28433
	],
	"./solid/republican.svg": [
		45001,
		45001
	],
	"./solid/restroom.svg": [
		80749,
		80749
	],
	"./solid/retweet.svg": [
		37923,
		37923
	],
	"./solid/ribbon.svg": [
		79331,
		79331
	],
	"./solid/right-from-bracket.svg": [
		78406,
		67461
	],
	"./solid/right-left.svg": [
		96972,
		96972
	],
	"./solid/right-long.svg": [
		13830,
		13830
	],
	"./solid/right-to-bracket.svg": [
		26141,
		26141
	],
	"./solid/ring.svg": [
		66599,
		66599
	],
	"./solid/road-barrier.svg": [
		97361,
		97361
	],
	"./solid/road-bridge.svg": [
		40986,
		40986
	],
	"./solid/road-circle-check.svg": [
		41044,
		41044
	],
	"./solid/road-circle-exclamation.svg": [
		29507,
		29507
	],
	"./solid/road-circle-xmark.svg": [
		7934,
		7934
	],
	"./solid/road-lock.svg": [
		2993,
		2993
	],
	"./solid/road-spikes.svg": [
		24202,
		24202
	],
	"./solid/road.svg": [
		71610,
		71610
	],
	"./solid/robot.svg": [
		93703,
		93703
	],
	"./solid/rocket.svg": [
		21406,
		21406
	],
	"./solid/rotate-left.svg": [
		551,
		551
	],
	"./solid/rotate-right.svg": [
		97090,
		97090
	],
	"./solid/rotate.svg": [
		21752,
		21752
	],
	"./solid/route.svg": [
		72020,
		72020
	],
	"./solid/rss.svg": [
		78586,
		78586
	],
	"./solid/ruble-sign.svg": [
		86073,
		86073
	],
	"./solid/rug.svg": [
		92787,
		92787
	],
	"./solid/ruler-combined.svg": [
		26388,
		26388
	],
	"./solid/ruler-horizontal.svg": [
		66536,
		66536
	],
	"./solid/ruler-vertical.svg": [
		329,
		329
	],
	"./solid/ruler.svg": [
		14716,
		14716
	],
	"./solid/rupee-sign.svg": [
		22445,
		22445
	],
	"./solid/rupiah-sign.svg": [
		76778,
		76778
	],
	"./solid/s.svg": [
		74897,
		74897
	],
	"./solid/sack-dollar.svg": [
		39498,
		39498
	],
	"./solid/sack-xmark.svg": [
		84297,
		84297
	],
	"./solid/sailboat.svg": [
		10633,
		10633
	],
	"./solid/satellite-dish.svg": [
		17358,
		17358
	],
	"./solid/satellite.svg": [
		81591,
		81591
	],
	"./solid/scale-balanced.svg": [
		67647,
		67647
	],
	"./solid/scale-unbalanced-flip.svg": [
		80386,
		983
	],
	"./solid/scale-unbalanced.svg": [
		97840,
		97840
	],
	"./solid/school-circle-check.svg": [
		40135,
		40135
	],
	"./solid/school-circle-exclamation.svg": [
		47143,
		47143
	],
	"./solid/school-circle-xmark.svg": [
		279,
		279
	],
	"./solid/school-flag.svg": [
		26733,
		26733
	],
	"./solid/school-lock.svg": [
		46954,
		46954
	],
	"./solid/school.svg": [
		55198,
		55198
	],
	"./solid/scissors.svg": [
		85335,
		85335
	],
	"./solid/screwdriver-wrench.svg": [
		33267,
		33267
	],
	"./solid/screwdriver.svg": [
		90333,
		90333
	],
	"./solid/scroll-torah.svg": [
		64656,
		64656
	],
	"./solid/scroll.svg": [
		94830,
		94830
	],
	"./solid/sd-card.svg": [
		18335,
		18335
	],
	"./solid/section.svg": [
		27301,
		27301
	],
	"./solid/seedling.svg": [
		72260,
		72260
	],
	"./solid/server.svg": [
		99017,
		99017
	],
	"./solid/shapes.svg": [
		90681,
		90681
	],
	"./solid/share-from-square.svg": [
		69969,
		69969
	],
	"./solid/share-nodes.svg": [
		54978,
		54978
	],
	"./solid/share.svg": [
		83598,
		83598
	],
	"./solid/sheet-plastic.svg": [
		29191,
		29191
	],
	"./solid/shekel-sign.svg": [
		27953,
		27953
	],
	"./solid/shield-cat.svg": [
		19211,
		19211
	],
	"./solid/shield-dog.svg": [
		47756,
		47756
	],
	"./solid/shield-halved.svg": [
		37793,
		37793
	],
	"./solid/shield-heart.svg": [
		27710,
		27710
	],
	"./solid/shield-virus.svg": [
		98170,
		98170
	],
	"./solid/shield.svg": [
		39720,
		39720
	],
	"./solid/ship.svg": [
		42297,
		42297
	],
	"./solid/shirt.svg": [
		20832,
		20832
	],
	"./solid/shoe-prints.svg": [
		7266,
		7266
	],
	"./solid/shop-lock.svg": [
		44610,
		44610
	],
	"./solid/shop-slash.svg": [
		3825,
		3825
	],
	"./solid/shop.svg": [
		38522,
		38522
	],
	"./solid/shower.svg": [
		84314,
		84314
	],
	"./solid/shrimp.svg": [
		25738,
		25738
	],
	"./solid/shuffle.svg": [
		72878,
		72878
	],
	"./solid/shuttle-space.svg": [
		46073,
		73775
	],
	"./solid/sign-hanging.svg": [
		77080,
		77080
	],
	"./solid/signal.svg": [
		49561,
		49561
	],
	"./solid/signature.svg": [
		88093,
		88093
	],
	"./solid/signs-post.svg": [
		8665,
		8665
	],
	"./solid/sim-card.svg": [
		49824,
		49824
	],
	"./solid/sink.svg": [
		30549,
		30549
	],
	"./solid/sitemap.svg": [
		11421,
		11421
	],
	"./solid/skull-crossbones.svg": [
		13490,
		13490
	],
	"./solid/skull.svg": [
		74364,
		74364
	],
	"./solid/slash.svg": [
		54188,
		54188
	],
	"./solid/sleigh.svg": [
		67142,
		67142
	],
	"./solid/sliders.svg": [
		90929,
		90929
	],
	"./solid/smog.svg": [
		8640,
		8640
	],
	"./solid/smoking.svg": [
		4,
		4
	],
	"./solid/snowflake.svg": [
		8082,
		8082
	],
	"./solid/snowman.svg": [
		71555,
		71555
	],
	"./solid/snowplow.svg": [
		88142,
		88142
	],
	"./solid/soap.svg": [
		54338,
		54338
	],
	"./solid/socks.svg": [
		65368,
		65368
	],
	"./solid/solar-panel.svg": [
		21441,
		21441
	],
	"./solid/sort-down.svg": [
		43357,
		43357
	],
	"./solid/sort-up.svg": [
		80637,
		80637
	],
	"./solid/sort.svg": [
		67923,
		67923
	],
	"./solid/spa.svg": [
		54734,
		54734
	],
	"./solid/spaghetti-monster-flying.svg": [
		45729,
		45729
	],
	"./solid/spell-check.svg": [
		91407,
		91407
	],
	"./solid/spider.svg": [
		70593,
		70593
	],
	"./solid/spinner.svg": [
		20557,
		20557
	],
	"./solid/splotch.svg": [
		41372,
		41372
	],
	"./solid/spoon.svg": [
		8207,
		8207
	],
	"./solid/spray-can-sparkles.svg": [
		27734,
		27734
	],
	"./solid/spray-can.svg": [
		91783,
		91783
	],
	"./solid/square-arrow-up-right.svg": [
		16054,
		16054
	],
	"./solid/square-caret-down.svg": [
		41213,
		41213
	],
	"./solid/square-caret-left.svg": [
		12718,
		12718
	],
	"./solid/square-caret-right.svg": [
		71621,
		71621
	],
	"./solid/square-caret-up.svg": [
		39627,
		39627
	],
	"./solid/square-check.svg": [
		35010,
		35010
	],
	"./solid/square-envelope.svg": [
		95117,
		95117
	],
	"./solid/square-full.svg": [
		75711,
		75711
	],
	"./solid/square-h.svg": [
		14520,
		14520
	],
	"./solid/square-minus.svg": [
		96502,
		96502
	],
	"./solid/square-nfi.svg": [
		10111,
		10111
	],
	"./solid/square-parking.svg": [
		86018,
		86018
	],
	"./solid/square-pen.svg": [
		73990,
		80919
	],
	"./solid/square-person-confined.svg": [
		32938,
		32938
	],
	"./solid/square-phone-flip.svg": [
		27718,
		27718
	],
	"./solid/square-phone.svg": [
		99220,
		99220
	],
	"./solid/square-plus.svg": [
		53491,
		53491
	],
	"./solid/square-poll-horizontal.svg": [
		120,
		120
	],
	"./solid/square-poll-vertical.svg": [
		61915,
		61915
	],
	"./solid/square-root-variable.svg": [
		61805,
		61805
	],
	"./solid/square-rss.svg": [
		22416,
		22416
	],
	"./solid/square-share-nodes.svg": [
		45711,
		45711
	],
	"./solid/square-up-right.svg": [
		55424,
		55424
	],
	"./solid/square-virus.svg": [
		18151,
		18151
	],
	"./solid/square-xmark.svg": [
		87509,
		87509
	],
	"./solid/square.svg": [
		3201,
		3201
	],
	"./solid/staff-snake.svg": [
		75943,
		75943
	],
	"./solid/stairs.svg": [
		7624,
		24560
	],
	"./solid/stamp.svg": [
		6642,
		6642
	],
	"./solid/stapler.svg": [
		80627,
		80627
	],
	"./solid/star-and-crescent.svg": [
		88391,
		88391
	],
	"./solid/star-half-stroke.svg": [
		60754,
		60754
	],
	"./solid/star-half.svg": [
		85941,
		85941
	],
	"./solid/star-of-david.svg": [
		23092,
		23092
	],
	"./solid/star-of-life.svg": [
		53946,
		53946
	],
	"./solid/star.svg": [
		82763,
		82763
	],
	"./solid/sterling-sign.svg": [
		42082,
		42082
	],
	"./solid/stethoscope.svg": [
		53829,
		53829
	],
	"./solid/stop.svg": [
		80323,
		80323
	],
	"./solid/stopwatch-20.svg": [
		29911,
		29911
	],
	"./solid/stopwatch.svg": [
		6790,
		6790
	],
	"./solid/store-slash.svg": [
		25387,
		25387
	],
	"./solid/store.svg": [
		72117,
		72117
	],
	"./solid/street-view.svg": [
		38321,
		38321
	],
	"./solid/strikethrough.svg": [
		24559,
		24559
	],
	"./solid/stroopwafel.svg": [
		47427,
		47427
	],
	"./solid/subscript.svg": [
		76101,
		76101
	],
	"./solid/suitcase-medical.svg": [
		78298,
		78298
	],
	"./solid/suitcase-rolling.svg": [
		98272,
		98272
	],
	"./solid/suitcase.svg": [
		84361,
		84361
	],
	"./solid/sun-plant-wilt.svg": [
		69121,
		69121
	],
	"./solid/sun.svg": [
		7123,
		7123
	],
	"./solid/superscript.svg": [
		57046,
		57046
	],
	"./solid/swatchbook.svg": [
		13875,
		13875
	],
	"./solid/synagogue.svg": [
		56105,
		56105
	],
	"./solid/syringe.svg": [
		16141,
		16141
	],
	"./solid/t.svg": [
		25556,
		25556
	],
	"./solid/table-cells-large.svg": [
		39977,
		39977
	],
	"./solid/table-cells.svg": [
		80392,
		80392
	],
	"./solid/table-columns.svg": [
		67960,
		67960
	],
	"./solid/table-list.svg": [
		92124,
		92124
	],
	"./solid/table-tennis-paddle-ball.svg": [
		77646,
		77646
	],
	"./solid/table.svg": [
		57276,
		57276
	],
	"./solid/tablet-button.svg": [
		16467,
		16467
	],
	"./solid/tablet-screen-button.svg": [
		83799,
		83799
	],
	"./solid/tablet.svg": [
		9304,
		9304
	],
	"./solid/tablets.svg": [
		52369,
		52369
	],
	"./solid/tachograph-digital.svg": [
		76010,
		76010
	],
	"./solid/tag.svg": [
		56361,
		56361
	],
	"./solid/tags.svg": [
		8361,
		8361
	],
	"./solid/tape.svg": [
		13048,
		13048
	],
	"./solid/tarp-droplet.svg": [
		45347,
		45347
	],
	"./solid/tarp.svg": [
		90250,
		90250
	],
	"./solid/taxi.svg": [
		92281,
		92281
	],
	"./solid/teeth-open.svg": [
		36319,
		36319
	],
	"./solid/teeth.svg": [
		55501,
		55501
	],
	"./solid/temperature-arrow-down.svg": [
		14678,
		14678
	],
	"./solid/temperature-arrow-up.svg": [
		79657,
		79657
	],
	"./solid/temperature-empty.svg": [
		70578,
		70578
	],
	"./solid/temperature-full.svg": [
		14072,
		14072
	],
	"./solid/temperature-half.svg": [
		31783,
		31783
	],
	"./solid/temperature-high.svg": [
		40967,
		40967
	],
	"./solid/temperature-low.svg": [
		78158,
		78158
	],
	"./solid/temperature-quarter.svg": [
		37806,
		37806
	],
	"./solid/temperature-three-quarters.svg": [
		25653,
		25653
	],
	"./solid/tenge-sign.svg": [
		90831,
		90831
	],
	"./solid/tent-arrow-down-to-line.svg": [
		20627,
		20627
	],
	"./solid/tent-arrow-left-right.svg": [
		66916,
		66916
	],
	"./solid/tent-arrow-turn-left.svg": [
		64242,
		64242
	],
	"./solid/tent-arrows-down.svg": [
		66184,
		66184
	],
	"./solid/tent.svg": [
		42437,
		42437
	],
	"./solid/tents.svg": [
		21749,
		43110
	],
	"./solid/terminal.svg": [
		84001,
		84001
	],
	"./solid/text-height.svg": [
		81446,
		81446
	],
	"./solid/text-slash.svg": [
		35963,
		35963
	],
	"./solid/text-width.svg": [
		74398,
		74398
	],
	"./solid/thermometer.svg": [
		4078,
		4078
	],
	"./solid/thumbs-down.svg": [
		96168,
		96168
	],
	"./solid/thumbs-up.svg": [
		47786,
		47786
	],
	"./solid/thumbtack.svg": [
		96404,
		96404
	],
	"./solid/ticket-simple.svg": [
		67398,
		67398
	],
	"./solid/ticket.svg": [
		81823,
		81823
	],
	"./solid/timeline.svg": [
		319,
		319
	],
	"./solid/toggle-off.svg": [
		91240,
		91240
	],
	"./solid/toggle-on.svg": [
		84538,
		84538
	],
	"./solid/toilet-paper-slash.svg": [
		16618,
		16618
	],
	"./solid/toilet-paper.svg": [
		32194,
		32194
	],
	"./solid/toilet-portable.svg": [
		95872,
		95872
	],
	"./solid/toilet.svg": [
		60501,
		60501
	],
	"./solid/toilets-portable.svg": [
		17960,
		17960
	],
	"./solid/toolbox.svg": [
		86577,
		86577
	],
	"./solid/tooth.svg": [
		2857,
		2857
	],
	"./solid/torii-gate.svg": [
		37549,
		37549
	],
	"./solid/tornado.svg": [
		75584,
		75584
	],
	"./solid/tower-broadcast.svg": [
		3005,
		3005
	],
	"./solid/tower-cell.svg": [
		93518,
		93518
	],
	"./solid/tower-observation.svg": [
		33777,
		33777
	],
	"./solid/tractor.svg": [
		64318,
		64318
	],
	"./solid/trademark.svg": [
		73051,
		73051
	],
	"./solid/traffic-light.svg": [
		35143,
		35143
	],
	"./solid/trailer.svg": [
		8135,
		8135
	],
	"./solid/train-subway.svg": [
		12903,
		12903
	],
	"./solid/train-tram.svg": [
		82173,
		82173
	],
	"./solid/train.svg": [
		58300,
		58300
	],
	"./solid/transgender.svg": [
		66234,
		66234
	],
	"./solid/trash-arrow-up.svg": [
		71561,
		71561
	],
	"./solid/trash-can-arrow-up.svg": [
		14272,
		14272
	],
	"./solid/trash-can.svg": [
		29774,
		29774
	],
	"./solid/trash.svg": [
		66648,
		66648
	],
	"./solid/tree-city.svg": [
		60498,
		60498
	],
	"./solid/tree.svg": [
		97388,
		97388
	],
	"./solid/triangle-exclamation.svg": [
		11959,
		11959
	],
	"./solid/trophy.svg": [
		40758,
		40758
	],
	"./solid/trowel-bricks.svg": [
		22669,
		22669
	],
	"./solid/trowel.svg": [
		68226,
		68226
	],
	"./solid/truck-arrow-right.svg": [
		73509,
		73509
	],
	"./solid/truck-droplet.svg": [
		35005,
		35005
	],
	"./solid/truck-fast.svg": [
		51356,
		51356
	],
	"./solid/truck-field-un.svg": [
		44381,
		44381
	],
	"./solid/truck-field.svg": [
		40831,
		40831
	],
	"./solid/truck-front.svg": [
		97275,
		97275
	],
	"./solid/truck-medical.svg": [
		50337,
		50337
	],
	"./solid/truck-monster.svg": [
		15722,
		15722
	],
	"./solid/truck-moving.svg": [
		42758,
		42758
	],
	"./solid/truck-pickup.svg": [
		61471,
		23149
	],
	"./solid/truck-plane.svg": [
		87936,
		87936
	],
	"./solid/truck-ramp-box.svg": [
		17401,
		17401
	],
	"./solid/truck.svg": [
		75686,
		75686
	],
	"./solid/tty.svg": [
		7245,
		7245
	],
	"./solid/turkish-lira-sign.svg": [
		22587,
		22587
	],
	"./solid/turn-down.svg": [
		61553,
		61553
	],
	"./solid/turn-up.svg": [
		62969,
		62969
	],
	"./solid/tv.svg": [
		40256,
		40256
	],
	"./solid/u.svg": [
		26365,
		26365
	],
	"./solid/umbrella-beach.svg": [
		11546,
		11546
	],
	"./solid/umbrella.svg": [
		69786,
		69786
	],
	"./solid/underline.svg": [
		23891,
		23891
	],
	"./solid/universal-access.svg": [
		87068,
		87068
	],
	"./solid/unlock-keyhole.svg": [
		24632,
		24632
	],
	"./solid/unlock.svg": [
		34610,
		34610
	],
	"./solid/up-down-left-right.svg": [
		55811,
		55811
	],
	"./solid/up-down.svg": [
		10809,
		10809
	],
	"./solid/up-long.svg": [
		82351,
		82351
	],
	"./solid/up-right-and-down-left-from-center.svg": [
		76220,
		76220
	],
	"./solid/up-right-from-square.svg": [
		67566,
		67566
	],
	"./solid/upload.svg": [
		38631,
		38631
	],
	"./solid/user-astronaut.svg": [
		14950,
		14950
	],
	"./solid/user-check.svg": [
		56770,
		56770
	],
	"./solid/user-clock.svg": [
		78946,
		78946
	],
	"./solid/user-doctor.svg": [
		89138,
		89138
	],
	"./solid/user-gear.svg": [
		29294,
		29294
	],
	"./solid/user-graduate.svg": [
		50519,
		50519
	],
	"./solid/user-group.svg": [
		95161,
		95161
	],
	"./solid/user-injured.svg": [
		16628,
		16628
	],
	"./solid/user-large-slash.svg": [
		82483,
		82483
	],
	"./solid/user-large.svg": [
		89627,
		89627
	],
	"./solid/user-lock.svg": [
		32997,
		32997
	],
	"./solid/user-minus.svg": [
		85726,
		62663
	],
	"./solid/user-ninja.svg": [
		85698,
		85698
	],
	"./solid/user-nurse.svg": [
		88731,
		88731
	],
	"./solid/user-pen.svg": [
		88740,
		88740
	],
	"./solid/user-plus.svg": [
		41799,
		41799
	],
	"./solid/user-secret.svg": [
		58629,
		58629
	],
	"./solid/user-shield.svg": [
		33964,
		33964
	],
	"./solid/user-slash.svg": [
		31973,
		31973
	],
	"./solid/user-tag.svg": [
		17252,
		17252
	],
	"./solid/user-tie.svg": [
		82344,
		82344
	],
	"./solid/user-xmark.svg": [
		51020,
		51020
	],
	"./solid/user.svg": [
		94391,
		94391
	],
	"./solid/users-between-lines.svg": [
		61261,
		61261
	],
	"./solid/users-gear.svg": [
		68256,
		68256
	],
	"./solid/users-line.svg": [
		54199,
		54199
	],
	"./solid/users-rays.svg": [
		39555,
		39555
	],
	"./solid/users-rectangle.svg": [
		21816,
		21816
	],
	"./solid/users-slash.svg": [
		46111,
		46111
	],
	"./solid/users-viewfinder.svg": [
		19017,
		19017
	],
	"./solid/users.svg": [
		54426,
		54426
	],
	"./solid/utensils.svg": [
		27437,
		27437
	],
	"./solid/v.svg": [
		82435,
		82435
	],
	"./solid/van-shuttle.svg": [
		90061,
		90061
	],
	"./solid/vault.svg": [
		50173,
		50173
	],
	"./solid/vector-square.svg": [
		16822,
		16822
	],
	"./solid/venus-double.svg": [
		70086,
		70086
	],
	"./solid/venus-mars.svg": [
		74222,
		74222
	],
	"./solid/venus.svg": [
		59591,
		59591
	],
	"./solid/vest-patches.svg": [
		4983,
		4983
	],
	"./solid/vest.svg": [
		63367,
		63367
	],
	"./solid/vial-circle-check.svg": [
		15529,
		15529
	],
	"./solid/vial-virus.svg": [
		30041,
		30041
	],
	"./solid/vial.svg": [
		73758,
		73758
	],
	"./solid/vials.svg": [
		10727,
		10727
	],
	"./solid/video-slash.svg": [
		86549,
		86549
	],
	"./solid/video.svg": [
		29780,
		29780
	],
	"./solid/vihara.svg": [
		96863,
		96863
	],
	"./solid/virus-covid-slash.svg": [
		89620,
		89620
	],
	"./solid/virus-covid.svg": [
		49836,
		49836
	],
	"./solid/virus-slash.svg": [
		33654,
		33654
	],
	"./solid/virus.svg": [
		24622,
		24622
	],
	"./solid/viruses.svg": [
		88357,
		88357
	],
	"./solid/voicemail.svg": [
		23047,
		23047
	],
	"./solid/volcano.svg": [
		7352,
		80797
	],
	"./solid/volleyball.svg": [
		96845,
		96845
	],
	"./solid/volume-high.svg": [
		36483,
		36483
	],
	"./solid/volume-low.svg": [
		54079,
		54079
	],
	"./solid/volume-off.svg": [
		36847,
		36847
	],
	"./solid/volume-xmark.svg": [
		21391,
		21391
	],
	"./solid/vr-cardboard.svg": [
		57552,
		57552
	],
	"./solid/w.svg": [
		56727,
		56727
	],
	"./solid/walkie-talkie.svg": [
		7067,
		7067
	],
	"./solid/wallet.svg": [
		41882,
		41882
	],
	"./solid/wand-magic-sparkles.svg": [
		54680,
		54680
	],
	"./solid/wand-magic.svg": [
		16527,
		16527
	],
	"./solid/wand-sparkles.svg": [
		704,
		704
	],
	"./solid/warehouse.svg": [
		60743,
		60743
	],
	"./solid/water-ladder.svg": [
		43468,
		43468
	],
	"./solid/water.svg": [
		33590,
		33590
	],
	"./solid/wave-square.svg": [
		15566,
		15566
	],
	"./solid/weight-hanging.svg": [
		90439,
		90439
	],
	"./solid/weight-scale.svg": [
		91987,
		91987
	],
	"./solid/wheat-awn-circle-exclamation.svg": [
		76319,
		76319
	],
	"./solid/wheat-awn.svg": [
		29300,
		29300
	],
	"./solid/wheelchair-move.svg": [
		84358,
		84358
	],
	"./solid/wheelchair.svg": [
		87337,
		87337
	],
	"./solid/whiskey-glass.svg": [
		67129,
		67129
	],
	"./solid/wifi.svg": [
		80337,
		80337
	],
	"./solid/wind.svg": [
		20574,
		20574
	],
	"./solid/window-maximize.svg": [
		2949,
		2949
	],
	"./solid/window-minimize.svg": [
		31389,
		31389
	],
	"./solid/window-restore.svg": [
		66348,
		66348
	],
	"./solid/wine-bottle.svg": [
		26845,
		26845
	],
	"./solid/wine-glass-empty.svg": [
		9625,
		9625
	],
	"./solid/wine-glass.svg": [
		27926,
		27926
	],
	"./solid/won-sign.svg": [
		914,
		914
	],
	"./solid/worm.svg": [
		7943,
		7943
	],
	"./solid/wrench.svg": [
		23973,
		23973
	],
	"./solid/x-ray.svg": [
		98374,
		98374
	],
	"./solid/x.svg": [
		90372,
		90372
	],
	"./solid/xmark.svg": [
		63193,
		63193
	],
	"./solid/xmarks-lines.svg": [
		2023,
		2023
	],
	"./solid/y.svg": [
		61477,
		61477
	],
	"./solid/yen-sign.svg": [
		275,
		275
	],
	"./solid/yin-yang.svg": [
		14213,
		14213
	],
	"./solid/z.svg": [
		75475,
		75475
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 32145;
module.exports = webpackAsyncContext;